(function(){
/* Layout/hide CSS is gated on .vvbc-pre so it applies at parse time — BEFORE first paint of the
   old controls (prevents the old-style flash). If enhancement never boots, roll back to native UI. */
document.documentElement.classList.add('vvbc-pre');
setTimeout(function(){if(!document.querySelector('.vvbc'))document.documentElement.classList.remove('vvbc-pre');},9000);
/* Legacy #AddToCart calls addItem(), which is no longer defined anywhere — the onclick threw, its
   `return false` never ran, and the form posted natively to /cart/add (white page). Shim it:
   AJAX the button's form to /cart/add.js and land on the basket (reference/prototype behaviour). */
/* 24-Aug bug #101: on native buy-flow products the "Expert designer" fee ($99/$199,
   server-rendered into #design_charges_dpo by design_block.liquid) is charged as its own
   line from the hidden Professional Design Service product. ITORIS products (window.dpoOptions
   present) charge it themselves — this must no-op there. Called before every navigation to
   /cart so the fee line is in the basket the customer is about to look at. */
function vvFeeThen(cb){
  cb=cb||function(){};
  try{
    if(window.dpoOptions){cb();return;}
    if(!document.body.classList.contains('design_assist')){cb();return;}
    var fee=(window.vvDesignFee&&window.vvDesignFee())||0;
    var vid={99:45593650987077,199:45593651085381}[fee];
    if(!fee||!vid){cb();return;}   // unknown amount: never guess a charge
    var p=new URLSearchParams({id:String(vid),quantity:'1'});
    p.set('properties[_Design fee for]',document.title.replace(/\s+/g,' ').trim());
    p.set('properties[_Additional Design Charges]','$'+fee.toFixed(2));
    /* 28-Aug (owner, Shabbir report 27-Aug #3): the fee line must TELL the customer
       what happens — visible property (no underscore) so it renders in the cart. */
    p.set('properties[What happens next]','Our design team will contact you for your brief after you place your order — unlimited revisions included.');
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded',Accept:'application/json'},body:p.toString()})
      .then(function(){cb();},function(){cb();});
  }catch(e){cb();}
}
if(typeof window.addItem==='undefined'){
  window.addItem=function(formId){
    try{
      var f=document.getElementById(formId);
      if(!f){var b=document.getElementById('AddToCart');f=b&&b.closest('form');}
      if(!f)return false;
      var fd=new FormData(f);
      if(!fd.get('id')){ // the legacy form ships WITHOUT the variant id — the actual cause of the 400/white page
        var vsel=document.querySelector('select[name="id"], input[name="id"], variant-selects select[name="id"]');
        if(vsel&&vsel.value)fd.set('id',vsel.value);
      }
      if(!fd.get('quantity'))fd.set('quantity','1');
      fetch('/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}})
        .then(function(r){return r.json();})
        .then(function(j){
          if(j&&(j.id!==undefined||j.product_title)){vvFeeThen(function(){try{window.__vvNoNav=1;}catch(e){}window.location.href='/cart';});}
          else{console.warn('add-to-cart:',j&&(j.description||j.message));}
        }).catch(function(e){console.warn('add-to-cart failed',e);});
    }catch(e){}
    return false;
  };
}
var TRIES=0;
function money(c){return '$'+(c/100).toFixed(2);}
/* 19-Aug: pin the viewport while ITORIS/Dawn re-render after a size/qty click — the legacy
   widgets mutate the DOM for ~1s and browser scroll anchoring dragged the page "here and
   there" (owner report, mobile). Releases instantly on any user gesture. */
function vvPin(ms){var y=window.pageYOffset,stop=false,off=function(){stop=true;};
  ['touchstart','wheel','keydown','pointerdown'].forEach(function(ev){window.addEventListener(ev,off,{once:true,passive:true});});
  var t0=Date.now();var iv=setInterval(function(){
    if(stop||Date.now()-t0>ms){clearInterval(iv);return;}
    if(Math.abs(window.pageYOffset-y)>1)window.scrollTo(0,y);
  },80);}
/* 17-Aug BEST SELLER BADGING (owner: "recommended should be based on the best selling
   ones as per the sales data"). RECOMMENDED used to sit on the FIRST card and "most
   popular" on the MIDDLE one — both arbitrary. vivid-bestsellers.js carries a map of
   product handle -> {key: canonical winning size, share: % of units} built from Shopify
   sales (units sold per size, 12 months). vvBestKey() canonicalises a card label the same
   way the harvester canonicalises variant titles, so the badge lands on the size customers
   actually buy. No data for a product = the old first-card behaviour, unchanged. */
function vvCanonSize(nm){var s=String(nm||'').replace(/\s+/g,' ');
  var m=/(\d{3,5})\s*mm\s*W?\s*[×x]\s*(\d{3,5})\s*mm\s*H?/i.exec(s);
  if(m)return m[1]+'x'+m[2];
  m=/\(?\s*(\d{3,4})\s*mm\s*H\s*\)?/i.exec(s);
  if(m)return m[1]+'H';
  m=/(\d+(?:\.\d+)?)\s*(?:foot|ft)\b/i.exec(s);
  if(m)return parseFloat(m[1])+'FOOT';
  return s.toLowerCase().replace(/\s*-\s*sale\b/,'').trim();
}
function vvBest(handle){try{
  var M=window.__VVBEST||{}; return M[handle]||null;
}catch(e){return null;}}
/* Synchronous-ish load: the map is fetched during idle time (see the warmer above) and is
   also fetched here on first boot. Cards render immediately either way — if the map has not
   landed yet the badge falls back to first-card, then re-renders on the next variant change.
   Deliberately NOT blocking: a 1KB lookup must never delay the buy box. */
function vvLoadBest(){try{
  if(window.__VVBESTP)return window.__VVBESTP;
  var u=window.__VVBEST_URL; if(!u)return null;
  window.__VVBESTP=fetch(u,{credentials:'omit'}).then(function(r){return r.text();})
    .then(function(t){try{(0,eval)(t);}catch(e){} return window.__VVBEST||null;})
    .catch(function(){return null;});
  return window.__VVBESTP;
}catch(e){return null;}}
function vvIsBest(best,nm){ return !!(best&&best.key&&vvCanonSize(nm)===best.key); }
/* Post-load corrector. The map is fetched, so on a cold visit it can land AFTER the cards
   are painted (measured: the 700ms build-time race loses on first load). Rather than block
   the buy box, cards paint immediately with the first-card fallback and this moves the badge
   the moment the data arrives. Idempotent, and grid-agnostic so it also fixes the ITORIS
   size groups (corflute-class) without duplicating the logic. */
function vvFixBadges(){try{
  var cfgEl=document.getElementById('vvbc-data'); if(!cfgEl)return;
  var h=(JSON.parse(cfgEl.textContent)||{}).handle, b=vvBest(h); if(!b)return;
  [].forEach.call(document.querySelectorAll('.vvbc-cards'),function(grid){
    var cards=[].slice.call(grid.querySelectorAll('.vvbc-card'));
    if(cards.length<2)return;
    var win=-1;
    cards.forEach(function(c,ix){var nm=((c.querySelector('.vvbc-nm')||{}).textContent)||'';
      if(win<0&&vvIsBest(b,nm))win=ix;});
    if(win<0)return;                       /* not a size grid (or size not stocked) */
    cards.forEach(function(c,ix){
      var r=c.querySelector('.vvbc-rec'), sub=c.querySelector('.vvbc-sub');
      var nm=((c.querySelector('.vvbc-nm')||{}).textContent)||'';
      if(ix===win){
        if(!r){r=document.createElement('span');r.className='vvbc-rec';c.appendChild(r);}
        r.textContent='BEST SELLER';
        if(sub&&!/most popular/i.test(sub.textContent))
          sub.textContent=sub.textContent?('most popular · '+sub.textContent):'most popular';
        c.setAttribute('data-tip',nm+' — our best-selling size'
          +(b.share?', '+b.share+'% of all orders for this product.':'.'));
      }else{
        if(r)r.remove();
        if(sub)sub.textContent=sub.textContent.replace(/most popular\s*·?\s*/i,'').replace(/^\s*·\s*/,'').trim();
        if(/most popular choice/i.test(c.getAttribute('data-tip')||''))c.removeAttribute('data-tip');
      }
    });
  });
}catch(e){}}
/* 17-Aug MOBILE COLD-OPEN FIX (lives here — vivid-cc.liquid is at the 256KiB
   theme-file limit). Measured on throttled 4G + 4x CPU: tapping VividCanvas
   took 17.4s cold because the design registry (132KB gz), the CC storefront
   lib (148KB) and the guest handshake all START at tap time, competing with
   the PDP's late images/tags for the same thin pipe. Warm the HTTP cache
   during idle time + open the TLS connections early instead. */
(function(){try{
  /* 26-Aug: staticjs.blob.core.windows.net dropped from this list. It is now
     only the SDK fallback, so preconnecting it spent a DNS+TCP+TLS handshake
     on a host almost nobody will use — on a phone that is a wasted RTT at
     exactly the moment the PDP is fighting for the pipe. */
  ['https://portal.vividads.com.au','https://staticjs-aurigma.azureedge.net'].forEach(function(h){
    var l=document.createElement('link');l.rel='preconnect';l.href=h;if(h.indexOf('portal')>-1)l.crossOrigin='anonymous';document.head.appendChild(l);});
  addEventListener('load',function(){
    var ric=window.requestIdleCallback||function(f){setTimeout(f,2500);};
    ric(function(){try{
      /* 21-Aug: the warm is ~280KB (132KB registry + 148KB CC lib) spent on the
         chance the visitor designs. Worth it on a decent connection, rude on a
         metered or slow one — so skip it when the browser tells us to. The cold
         path still works, it is just the 17.4s open again for those users. */
      var c=navigator.connection||{};
      if(c.saveData===true||/(^|-)2g$/.test(c.effectiveType||''))return;
      /* best-seller map is tiny (<2KB) but non-blocking all the same */
      if(window.__VVBEST_URL&&!window.__VVBEST)vvLoadBest();
      /* 26-Aug SPEED — TWO THINGS THIS BLOCK USED TO DO THAT COST REAL SECONDS.
         1. It fetched the Customer's Canvas SDK. So did vivid-cc-app.js's own
            idle warmer, from the same requestIdleCallback tick — measured on a
            live corflute PDP as TWO requests for the same 150KB file starting
            1ms apart and taking 1.55s and 1.77s. lib() is memoised, but this
            fetch lives in a different script and never saw that memo, so the
            memo could not help. It is deleted here rather than there because
            vivid-cc-app's copy is the one that actually EVALUATES the bundle
            and is the one gated on the product really having a CC integration.
         2. Neither this nor the registry fetch checked whether the page HAS a
            design button, so every product page pulled the design registry —
            367KB brotli, 2.84MB parsed — for products where nothing can ever
            open the gallery.
         The registry prefetch stays, gated on the button being present. */
      /* 26-Aug: warm the SLICE when this product has one (37KB brotli on
         corflute, under 10KB on most), and only fall back to warming the full
         393KB registry when it does not. Warming the wrong one would hand back
         every byte the slice just saved. */
      if(document.querySelector('.vvbc-cta--canvas')){
        var vvreg=window.__VVREG_SLICE_URL||window.__VVREG_URL;
        if(vvreg)fetch(vvreg,{credentials:'omit'}).catch(function(){});
      }
    }catch(e){}});
  });
}catch(e){}})();
/* vivid 17-Aug v3 "Elevation": true-scale product silhouette + real human on a shared ground line.
   ONE global scale sitewide: human = 1750mm = 46px (VV_PXMM). Per-family scene height comes from the
   family's tallest option via vvPrepIll() (cap 190px). Metre gridlines + bold height hero. Any error
   falls back to the legacy red-box tile so cards never break. */
var VV_PXMM=46/1750,VV_SCENEH=66,VV_HUMAN='',VV_SHAPE='rect';
function vvShapeOf(handle,ptype){var s=((handle||'')+' '+(ptype||'')).toLowerCase();
  if(/teardrop/.test(s))return 'teardrop';
  if(/feather|flutter/.test(s))return 'feather';
  if(/bow.?flag|bow.?banner/.test(s))return 'bow';
  if(/pull.?up|roll.?up|retract/.test(s))return 'pullup';
  if(/throw|table.?cloth|table.?cover/.test(s))return 'throw';
  if(/wall|backdrop|back.?drop/.test(s))return 'wall';
  return 'rect';}
function vvDims(nm){var m=/(\d{2,5})\s*(?:mm)?\s*W?\s*[×x]\s*(\d{2,5})\s*mm\s*H?/i.exec(nm||'');
  if(m)return {W:+m[1],H:+m[2]};
  var asp={teardrop:.36,feather:.27,bow:.3}[VV_SHAPE]||.4;
  m=/\(?\s*(\d{3,4})\s*mm\s*H\s*\)?/i.exec(nm||'');
  if(m)return {W:Math.round(+m[1]*asp),H:+m[1]};
  m=/(\d+(?:\.\d+)?)\s*(?:foot|ft)\b/i.exec(nm||'');
  if(m){ /* "N Foot" = table WIDTH (throws) — table stands ~750mm tall */
    if(VV_SHAPE==='throw')return {W:Math.round(parseFloat(m[1])*305),H:750};
    var hf=Math.round(parseFloat(m[1])*305);return {W:Math.round(hf*asp),H:hf};}
  return null;}
function vvPrepIll(sel,handle,ptype,humanImg){try{
  VV_SHAPE=vvShapeOf(handle,ptype);VV_HUMAN=humanImg||'';
  var maxH=1750;
  if(sel)[].forEach.call(sel.options,function(o){var d=vvDims(o.textContent||o.value||'');if(d&&d.H>maxH)maxH=d.H;});
  VV_SCENEH=Math.min(190,Math.max(66,Math.round(maxH*VV_PXMM)+20));
}catch(e){}}
function vvShapeSvg(w,h){var R='#fa4b52',K='#20242b',P='';
  /* paths are built in REAL pixel space (no preserveAspectRatio stretch) so each
     silhouette keeps product-true geometry at any size — stretch was turning the
     teardrop into a sliver and detaching the pull-up base from its banner */
  function n(x){return Math.round(x*10)/10;}
  if(VV_SHAPE==='teardrop'){
    /* traced from vivid's own product photo: dome top following the curved pole, long diagonal
       right edge sweeping down-left to a point at the pole ~78% height, pole stub + ground below */
    var px=n(w*.12);
    P='<path d="M'+px+' '+n(h*.78)+
      ' C'+n(w*.1)+' '+n(h*.35)+' '+n(w*.2)+' '+n(h*.02)+' '+n(w*.55)+' '+n(h*.01)+
      ' C'+n(w*.85)+' 0 '+n(w*.99)+' '+n(h*.12)+' '+n(w*.96)+' '+n(h*.28)+
      ' C'+n(w*.9)+' '+n(h*.5)+' '+n(w*.5)+' '+n(h*.66)+' '+px+' '+n(h*.78)+
      ' Z" fill="'+R+'"/>'+
      '<path d="M'+px+' '+n(h*.8)+' C'+n(w*.1)+' '+n(h*.35)+' '+n(w*.2)+' '+n(h*.02)+' '+n(w*.55)+' '+n(h*.01)+
      '" fill="none" stroke="'+K+'" stroke-width="2"/>'+
      '<rect x="'+px+'" y="'+n(h*.78)+'" width="2" height="'+n(h*.22)+'" fill="'+K+'"/>';
  }else if(VV_SHAPE==='feather'){
    /* traced from vivid's own product photo: straight tall blade, rounded top cap over the pole,
       near-vertical outer edge, flat bottom just above the base */
    var pw2=Math.max(2,Math.min(3,w*.12)),x1=n(w*.16);
    P='<rect x="'+n(w*.16-pw2)+'" y="'+n(h*.02)+'" width="'+n(pw2)+'" height="'+n(h*.98)+'" rx="1" fill="'+K+'"/>'+
      '<path d="M'+x1+' '+n(h*.07)+
      ' C'+n(w*.3)+' 0 '+n(w*.75)+' 0 '+n(w*.9)+' '+n(h*.05)+
      ' C'+n(w*.99)+' '+n(h*.14)+' '+n(w*.97)+' '+n(h*.55)+' '+n(w*.88)+' '+n(h*.96)+
      ' L'+x1+' '+n(h*.96)+
      ' Z" fill="'+R+'"/>';
  }else if(VV_SHAPE==='bow'){
    var pw3=Math.max(2,Math.min(3,w*.1)),px3=n(w*.06);
    P='<rect x="'+px3+'" y="0" width="'+n(pw3)+'" height="'+h+'" rx="1" fill="'+K+'"/>'+
      '<path d="M'+n(w*.06+pw3)+' '+n(h*.04)+' L'+n(w*.96)+' 0'+
      ' C'+n(w)+' '+n(h*.3)+' '+n(w*.96)+' '+n(h*.55)+' '+n(w*.72)+' '+n(h*.68)+
      ' L'+n(w*.06+pw3)+' '+n(h*.74)+' Z" fill="'+R+'"/>';
  }else if(VV_SHAPE==='pullup'){
    var bh=Math.max(4,Math.min(7,h*.07));
    P='<rect x="'+n(w*.07)+'" y="0" width="'+n(w*.86)+'" height="'+n(h-bh)+'" fill="'+R+'"/>'+
      '<rect x="0" y="'+n(h-bh)+'" width="'+w+'" height="'+n(bh)+'" rx="'+n(bh/2)+'" fill="'+K+'"/>';
  }else if(VV_SHAPE==='throw'){
    P='<path d="M'+n(w*.13)+' 2 Q'+n(w*.13)+' 0 '+n(w*.15)+' 0 L'+n(w*.85)+' 0 Q'+n(w*.87)+' 0 '+n(w*.87)+' 2 L'+w+' '+h+' L0 '+h+' Z" fill="'+R+'"/>'+
      '<rect x="'+n(w*.13)+'" y="0" width="'+n(w*.74)+'" height="'+n(Math.min(4,h*.18))+'" fill="'+K+'" opacity=".15"/>';
  }else if(VV_SHAPE==='wall'){
    var fh=Math.max(3,Math.min(6,h*.05)),fw=Math.max(6,Math.min(14,w*.14));
    P='<rect x="0" y="0" width="'+w+'" height="'+n(h-fh)+'" rx="2" fill="'+R+'"/>'+
      '<rect x="'+n(w*.08)+'" y="'+n(h-fh)+'" width="'+n(fw)+'" height="'+n(fh)+'" fill="'+K+'"/>'+
      '<rect x="'+n(w*.92-fw)+'" y="'+n(h-fh)+'" width="'+n(fw)+'" height="'+n(fh)+'" fill="'+K+'"/>';
  }else P='<rect x="0" y="0" width="'+w+'" height="'+h+'" rx="2" fill="'+R+'"/>';
  return '<svg class="vvbc-shape" viewBox="0 0 '+w+' '+h+'" style="width:'+w+'px;height:'+h+'px;flex:none">'+P+'</svg>';}
function vvIll(nm){try{
  var d=vvDims(nm);
  if(!d)return '<span class="vvbc-ill"><i></i><u></u></span>';
  var w=Math.max(6,Math.round(d.W*VV_PXMM)),h=Math.max(8,Math.round(d.H*VV_PXMM));
  var SH=Math.min(190,Math.max(VV_SCENEH,h+14,66));
  var html='<span class="vvbc-ill vvbc-elev" style="height:'+SH+'px">';
  for(var mm=1000;mm*VV_PXMM<SH-14;mm+=1000)html+='<b class="vvbc-grid" style="bottom:'+Math.round(mm*VV_PXMM)+'px"></b>';
  var hv=VV_SHAPE==='throw'?d.W:d.H,hl=VV_SHAPE==='throw'?'WIDE':'TALL';
  var hero=hv>=1000?(Math.round(hv/100)/10)+'m':Math.round(hv/10)+'cm';
  html+='<em class="vvbc-hbig">'+hero+'<i>'+hl+'</i></em><b class="vvbc-shadow"></b>';
  var shape=vvShapeSvg(w,h); /* very wide displays: keep TRUE height scale, crop width with a fade */
  if(w>110)shape='<span class="vvbc-crop" style="width:110px;height:'+h+'px">'+shape+'</span>';
  html+=shape;
  html+=VV_HUMAN?'<img class="vvbc-human" src="'+VV_HUMAN+'" alt="" loading="lazy" style="height:46px">':'<u style="width:10px;height:46px"></u>';
  return html+'</span>';
}catch(e){return '<span class="vvbc-ill"><i></i><u></u></span>';}}
function boot(){
  var data=document.getElementById('vvbc-data');var vs=document.querySelector('variant-selects');
  if(!data||!vs){if(TRIES++<20)setTimeout(boot,500);return;}
  if(document.querySelector('.vvbc'))return;
  var cfg;try{cfg=JSON.parse(data.textContent);}catch(e){return;}
  var isTableCover=/^(fitted-table-cloths-throws|loose-table-cloths-throws|stretch-tablecloths-throws)$/.test(cfg.handle||'');
  /* Wait (briefly) for the best-seller map so the BEST SELLER badge is correct on FIRST
     paint rather than jumping after a re-render. Hard-capped at 700ms — the file is ~1KB
     and usually already in the HTTP cache from the idle warmer; if it is slow or missing we
     build immediately with the first-card fallback. boot() is re-entrant (guard above). */
  if(cfg.bestUrl&&!window.__VVBEST&&!window.__VVBESTWAITED){
    window.__VVBESTWAITED=1; window.__VVBEST_URL=cfg.bestUrl;
    var bp=vvLoadBest();
    if(bp){ Promise.race([bp,new Promise(function(r){setTimeout(r,700);})]).then(function(){boot();}); return; }
  }
  if(cfg.bestUrl)window.__VVBEST_URL=cfg.bestUrl;
  var sels=[].slice.call(vs.querySelectorAll('select'));
  var sizeIdx=-1,sizeSel=null;
  sels.forEach(function(s,i){if(/size/i.test(s.name)&&s.options.length>1){sizeSel=s;sizeIdx=cfg.optionNames.findIndex(function(n){return new RegExp(n,'i').test(s.name);});}});
  var wrap=document.createElement('div');wrap.className='vvbc';
  // tooltip copy — lifted verbatim from the approved prototype (plain text; CSS bubble renders it)
  var TIPS={
    size:'Sizes are the visible print area. Pick by where it’ll be seen — head-height suits most shops and events. Prices update live as you choose.',
    extras:'Optional add-ons applied to this order. Digital proof is emailed for your approval before anything prints.',
    qty:'Prices shown are per one design. Bulk discounts apply automatically to the whole order — for different artwork, add separate items to your cart.',
    deliv:'Pick the date you need it, not a vague turnaround. The fee covers your whole order. Miss the artwork cut-off and we rebook you to the next date automatically.',
    proof:'Digital proof — emailed before print.',
    same:'Urgent production. Standard: most orders dispatched within 24 hours of proof approval (approved by 3pm Melbourne time on a working day).'
  };
  if(isTableCover){
    TIPS.size='Choose the size that fits your table. Check the width, depth and height listed for this product under Table fit & sizes before ordering. Prices update as you choose.';
    TIPS.deliv='The date shown is estimated dispatch. Production starts after artwork or proof approval, subject to the production time shown for this product. Courier transit time is additional; see our shipping policy.';
    [].forEach.call(document.querySelectorAll('.vph-jump a[href="#vvsc-specs"]'),function(a){
      a.setAttribute('href','#desc');
      a.textContent='Table fit & sizes';
      a.addEventListener('click',function(){
        var desc=document.getElementById('desc'),details=desc&&desc.closest('details.vvd-acc');
        if(details)details.open=true;
      });
    });
  }
  function tip(k){return ' <span class="vvbc-tip" tabindex="0" data-tip="'+TIPS[k].replace(/"/g,'&quot;')+'">i</span>';}
  // single-option Size renders as its own fixed card (prototype), NOT in the strip
  var sizeSingle=null;sels.forEach(function(s){if(/size/i.test(s.name)&&s.options.length===1)sizeSingle=s;});
  // Included strip from the remaining single-option selects (Display / Printed Sides)
  var inc=[];sels.forEach(function(s){if(s.options.length===1&&!/size/i.test(s.name)){var tv0=s.options[0].textContent.trim();if(!/^default title$/i.test(tv0))inc.push(tv0);}});
  if(inc.length){var st=document.createElement('div');st.className='vvbc-strip';st.innerHTML='<b>✓ Included:</b> '+inc.join(' · ');wrap.appendChild(st);}
  /* 24-Aug (bug #85, Faris): a size card's price was decided ONCE, at build time, by
     matching the size option alone — cfg.variants.find(v => v.opts[sizeIdx]===val). On a
     flag that is whichever variant happens to come first: cheapest base, single-sided. So
     a customer who picked a Concrete base and Double-sided still read the Ground-Spike,
     single-sided price on every size card, and only found out at the total. Repaint the
     cards against the value currently selected in EVERY other option instead. */
  function vvEscRe(s){return String(s).replace(/[.*+?^${}()|[\]\\]/g,'\\$&');}
  function vvbcPaintSizeCards(){
    try{
      if(sizeIdx<0||!cfg||!cfg.variants||!cfg.variants.length)return;
      var vs3=document.querySelector('variant-selects');if(!vs3)return;
      var sels3=[].slice.call(vs3.querySelectorAll('select'));
      // current value per option index — the native selects are the source of truth
      var cur=[];
      sels3.forEach(function(s,pos){
        var ix=cfg.optionNames.findIndex(function(n){return new RegExp(vvEscRe(n),'i').test(s.name);});
        if(ix<0&&sels3.length===cfg.optionNames.length)ix=pos;   // unnamed selects: trust the order
        if(ix>=0)cur[ix]=s.value;
      });
      [].forEach.call(document.querySelectorAll('.vvbc-card[data-val]'),function(c){
        var pr=c.querySelector('.vvbc-pr');if(!pr)return;
        var val=c.getAttribute('data-val');
        var hit=cfg.variants.find(function(v){
          if(v.opts[sizeIdx]!==val)return false;
          for(var i=0;i<v.opts.length;i++){if(i!==sizeIdx&&cur[i]!=null&&v.opts[i]!==cur[i])return false;}
          return true;
        });
        // no variant for that exact combination — leave the old figure rather than invent one
        if(hit)pr.textContent=money(hit.price);
      });
    }catch(e){}
  }
  window.__vvbcPaintSizeCards=vvbcPaintSizeCards;
  // SIZE CARDS
  if(sizeSel){
    vvPrepIll(sizeSel,cfg.handle,cfg.ptype,cfg.humanImg);
    var lab=document.createElement('div');lab.className='vvbc-label';lab.innerHTML='<b>Size:</b> <span class="vvbc-cur"></span>'+tip('size');wrap.appendChild(lab);
    var grid=document.createElement('div');grid.className='vvbc-cards';wrap.appendChild(grid);
    // hide ITORIS leftover design-instance variants (e.g. "…(D#1OTBXDQ)") from the size cards
    var sizeOpts=[].filter.call(sizeSel.options,function(o){return !/\(?D#[A-Za-z0-9]{4,}/i.test(o.value);});
    /* tags: "most popular" now follows the SALES data, not the middle slot. compact/wide
       still describe the extremes by width. If we have no sales data, fall back to the
       old fixed trio so 3-size products read the same as before. */
    var vvB=vvBest(cfg.handle), vvBestIx=-1;
    if(vvB)sizeOpts.forEach(function(o,ix){var n0=o.value.replace(/\s*-\s*SALE!?/i,'');if(vvBestIx<0&&vvIsBest(vvB,n0))vvBestIx=ix;});
    var tags=[];
    if(vvBestIx>=0){ tags[vvBestIx]='most popular';
      if(sizeOpts.length>=3){ if(vvBestIx!==0)tags[0]='compact'; if(vvBestIx!==sizeOpts.length-1)tags[sizeOpts.length-1]='wide'; }
    } else if(sizeOpts.length===3){ tags=['compact','most popular','wide']; }
    sizeOpts.forEach(function(o,i){
      var val=o.value;var vv=cfg.variants.find(function(v){return sizeIdx>=0&&v.opts[sizeIdx]===val;});
      var sale=/SALE/i.test(val);var name=val.replace(/\s*-\s*SALE!?/i,'').replace(/\s+x\s+/i,' × ');
      /* 10-Sep: out of stock is Shopify inventory now (quantity 0, continue-selling off), not
         "OUT OF STOCK (ETA …)" typed into the size name — that text reached invoices, the
         Shopping feed said in-stock while the title said out, and the size stayed buyable.
         A size with no available variant renders greyed and unclickable, with the restock
         note from the variant metafield vivid.stock_note. Same shape as the closed Same Day card. */
      var oos=sizeIdx>=0&&cfg.variants.length>0&&!cfg.variants.some(function(v){return v.opts[sizeIdx]===val&&v.available!==false;});
      if(oos){
        var oosNote=(cfg.variants.find(function(v){return v.opts[sizeIdx]===val&&v.note;})||{}).note||'';
        var u=document.createElement('button');u.type='button';u.className='vvbc-card vvbc-oos';u.disabled=true;
        u.setAttribute('aria-disabled','true');u.setAttribute('data-oos',val);
        u.setAttribute('data-tip','Out of stock'+(oosNote?' — '+oosNote:'')+'. Choose another size, or request a quote and we will hold your order for the next delivery.');
        u.innerHTML=vvIll(name)+'<span class="vvbc-nm">'+name+'</span>'+
          '<span class="vvbc-sub">'+(oosNote||'Restocking soon')+'</span>'+
          '<span class="vvbc-pr">Out of stock</span>';
        grid.appendChild(u);
        return;
      }
      var c=document.createElement('button');c.type='button';c.className='vvbc-card';c.setAttribute('data-val',val);
      c.innerHTML=vvIll(name)+'<span class="vvbc-nm">'+name+'</span>'+
        '<span class="vvbc-sub">'+(tags[i]||'')+(sale?(tags[i]?' · ':'')+'SALE':'')+'</span>'+
        (vv?'<span class="vvbc-pr">'+money(vv.price)+'</span>':'')+
        (i===(vvBestIx>=0?vvBestIx:0)?'<span class="vvbc-rec">'+(vvBestIx>=0?'BEST SELLER':'RECOMMENDED')+'</span>':'');
      if(i===(vvBestIx>=0?vvBestIx:0))c.setAttribute('data-tip',name+(tags[i]?' — '+tags[i]:'')
        +(vvBestIx>=0&&vvB.share?'. Our best-selling size — '+vvB.share+'% of orders this size.':'. Our most popular choice.'));
      c.addEventListener('click',function(){vvPin(1600);sizeSel.value=val;sizeSel.dispatchEvent(new Event('change',{bubbles:true}));sync();
        try{ if(window.__vvConfirmSize) window.__vvConfirmSize(); }catch(e){}   // RC4: a size tap (even the pre-selected one) is the customer's choice
        /* 21-Aug: a size change changes the VARIANT, so every quantity price the
           page is showing is now for the wrong variant. Re-probe. (Guarded: only
           formula-priced products build repriceAll; on the CRO-ladder path this
           is a no-op and those products have no size tiles.) */
        if(window.__vvbcReprice)window.__vvbcReprice();
        else if(window.__vvbcSyncTotal)window.__vvbcSyncTotal();
        vvbcPaintSizeCards();});
      grid.appendChild(c);
    });
    /* Any change to a non-size option makes every size card's price stale. Bind once on
       variant-selects (it is moved around the panel, never rebuilt) so native dropdowns,
       option cards and keyboard changes all repaint by the same route; the delayed second
       pass catches a Shopify re-render of the option list. */
    /* 24-Aug bug #104/#105 (Joshua, "website price differs from cart price") — the second
       half of #96. #96 fixed the SIZE CARDS for a non-size option change, and this listener
       is what repaints them. But the quantity tiles and the "Total price" line are painted
       from a separate ITORIS probe (repriceAll), and that was only re-run from the size-card
       click handler. So changing Printed Sides or Flag Base left the tiles — and the total —
       on the previous variant's numbers. Measured on LIVE after the #96 fix shipped: feather
       flags Small / Double-sided / Ground Spike showed correct cards ($119.00) and a stale
       Total of $99.00, while the cart charged $119.00. Under-quoting by $20 on the biggest
       number on the page, then surprising the customer at checkout.
       Re-probe on ANY variant change, exactly as a size change already does. repriceAll()
       blanks the stale figures first and syncTotal()'s fallback paints the selected size
       card's own (now fully-option-aware) price meanwhile, so the customer never sees a
       wrong number and is never quoted under. Debounced internally, so the extra call from
       the size-card path is harmless. */
    (function(){var vsx=document.querySelector('variant-selects');
      if(vsx&&!vsx.__vvPaintBound){vsx.__vvPaintBound=1;
        vsx.addEventListener('change',function(){vvbcPaintSizeCards();setTimeout(vvbcPaintSizeCards,300);
          if(window.__vvbcReprice)window.__vvbcReprice();
          else if(window.__vvbcSyncTotal)window.__vvbcSyncTotal();
        },true);}})();
    vvbcPaintSizeCards();
  }else if(sizeSingle){ // one real size — prototype still shows it as a (fixed, selected) card
    vvPrepIll(sizeSingle,cfg.handle,cfg.ptype,cfg.humanImg);
    var lab1=document.createElement('div');lab1.className='vvbc-label';lab1.innerHTML='<b>Size:</b> <span class="vvbc-cur"></span>'+tip('size');wrap.appendChild(lab1);
    var grid1=document.createElement('div');grid1.className='vvbc-cards';wrap.appendChild(grid1);
    var val1=sizeSingle.options[0].value;
    var name1=val1.replace(/\s*-\s*SALE!?/i,'').replace(/\s+x\s+/i,' × ');
    var vv1=cfg.variants.find(function(v){return v.opts.indexOf(val1)>-1;})||cfg.variants[0];
    var c1=document.createElement('button');c1.type='button';c1.className='vvbc-card on vvbc-fixed';
    c1.innerHTML=vvIll(name1)+'<span class="vvbc-nm">'+name1+'</span>'+
      (/SALE/i.test(val1)?'<span class="vvbc-sub">SALE</span>':'')+
      (vv1?'<span class="vvbc-pr">'+money(vv1.price)+'</span>':'')+
      '<span class="vvbc-rec">RECOMMENDED</span>';
    c1.setAttribute('data-tip',name1+'. Our most popular choice.');
    grid1.appendChild(c1);
    var cur1=lab1.querySelector('.vvbc-cur');if(cur1)cur1.textContent=name1;
  }
  // EXTRAS CARDS from DPO selects (Yes/No toggles, or mandatory single-"Yes" fields).
  // Rebuildable: ITORIS re-renders its options after variant changes and can wipe/replace selects.
  function getDpo(){return [].slice.call(document.querySelectorAll('select.product-custom-option')).filter(function(s){return [].some.call(s.options,function(o){return /yes/i.test(o.textContent);});});}
  function subFor(t){if(/proof/i.test(t))return 'emailed before print';if(/same day|production/i.test(t))return '';return '';}
  var dpo=getDpo(),exEl=null,exGrid=null,exCards=[];
  function liveSel(name,fallback){var all=document.querySelectorAll('select.product-custom-option');for(var i=0;i<all.length;i++){if(all[i].name===name)return all[i];}return fallback;}
  function syncExtras(){exCards.forEach(function(x){var s=liveSel(x.name,x.sel);x.el.classList.toggle('on',x.fixed||s.value===x.yesVal);});}
  function hideDpo(){dpo.forEach(function(s){
    var sp=s.parentElement;if(sp)sp.style.display='none';
    var q=s,lab2=null;for(var k=0;k<4&&q;k++){q=q.parentElement;if(q){lab2=q.querySelector('label:not([style])');if(lab2&&/proof|production|same day/i.test(lab2.textContent)){lab2.style.display='none';break;}}}
  });}
  function buildExtras(){
    dpo=getDpo();
    if(exGrid){exGrid.remove();exGrid=null;}
    if(exEl){exEl.remove();exEl=null;}
    exCards=[];
    if(!dpo.length)return;
    exEl=document.createElement('div');exEl.className='vvbc-label';exEl.innerHTML='<b>Extras:</b>'+tip('extras');
    exGrid=document.createElement('div');exGrid.className='vvbc-cards vvbc-cards--extras';
    var anchor=wrap.querySelector('.vvbc-qlabel');
    wrap.insertBefore(exEl,anchor||null);wrap.insertBefore(exGrid,anchor||null);
    dpo.forEach(function(s){
      var opts=[].slice.call(s.options);
      var yes=opts.find(function(o){return /yes/i.test(o.textContent);})||opts[1];
      var no=opts.find(function(o){return /^no/i.test(o.textContent.trim());});
      if(!yes)return;
      var fixed=!no&&opts.length===1; // mandatory field — card shown pre-selected, not toggleable
      var pm=yes.textContent.match(/\$\s*([\d.,]+)/);
      var title=yes.textContent.replace(/[\(\)]/g,' ').replace(/\+?\s*\$\s*[\d.,]+/g,'').replace(/^Yes,?\s*(I want\s*)?/i,'').trim();
      if(!title){ // fall back to the field's own label (first TEXT node only — skips tooltip glyphs)
        var p=s,f=null;for(var k=0;k<4&&p;k++){p=p.parentElement;if(p){f=p.querySelector('label, .optionlabel, .admin__field-label');if(f){var tn='';[].forEach.call(f.childNodes,function(n){if(n.nodeType===3)tn+=n.nodeValue;});title=(tn.trim()||f.textContent.trim());if(title)break;}}}
        title=title||'Option';
      }
      title=title.replace(/\s+/g,' ').replace(/[^A-Za-z0-9)%+$.\- ]+\s*$/,'').trim();
      var sub=subFor(title);
      var c=document.createElement('button');c.type='button';c.className='vvbc-card vvbc-card--extra'+(fixed?' vvbc-fixed':'');
      if(/proof/i.test(title))c.setAttribute('data-tip',TIPS.proof);else if(/same day|production/i.test(title))c.setAttribute('data-tip',TIPS.same);
      c.innerHTML='<span class="vvbc-nm">'+title.charAt(0).toUpperCase()+title.slice(1)+'</span>'+(sub?'<span class="vvbc-sub">'+sub+'</span>':'')+(pm?'<span class="vvbc-pr">+ $'+pm[1]+'</span>':'');
      if(!fixed)c.addEventListener('click',function(){var ls=liveSel(s.name,s);var on=c.classList.toggle('on');ls.value=on?yes.value:(no?no.value:opts[0].value);ls.dispatchEvent(new Event('change',{bubbles:true}));});
      if(fixed||s.value===yes.value)c.classList.add('on');
      exCards.push({name:s.name,sel:s,el:c,yesVal:yes.value,fixed:fixed});
      exGrid.appendChild(c);
    });
    if(!exGrid.children.length){exGrid.remove();exEl.remove();exEl=exGrid=null;}
    hideDpo();
  }
  buildExtras();
  /* badge correction: if the sales map is already here, this is a no-op re-assert; if it is
     still in flight, the badge moves to the real best seller the moment it lands. */
  if(window.__VVBEST)vvFixBadges();
  else { var _bp=vvLoadBest(); if(_bp)_bp.then(vvFixBadges); }
  /* the ITORIS size groups further down are built after this line, and ITORIS re-renders its
     selects after option changes — a few idempotent passes keep the badge correct through both. */
  [400,1500,4000].forEach(function(ms){setTimeout(vvFixBadges,ms);});
  // ===== DPO OPTION TILES (corflute-class: ALL config lives in ITORIS selects, product has one variant) =====
  // Visible multi-option DPO selects (Size / Clear Eyelets / Cutting …) become prototype card groups.
  // Single-option DPO selects join a "Fixed:" strip. Price adornments are ITORIS's own `price` attrs;
  // per-size rates are probed from the live formula once path C primes it (Calculate). Guarded by
  // visibility, so pullup-class pages (selects hidden or variant-driven) are untouched.
  function dpoLabelFor(s){var p=s,f=null,t='';for(var k=0;k<4&&p;k++){p=p.parentElement;if(p){f=p.querySelector('label, .optionlabel');if(f){t='';[].forEach.call(f.childNodes,function(n){if(n.nodeType===3)t+=n.nodeValue;});t=(t||f.textContent||'').replace(/[*]/g,'').replace(/\s+/g,' ').trim();if(t)break;}}}return t;}
  function getOptSels(){return [].slice.call(document.querySelectorAll('select.product-custom-option')).filter(function(s){
    return s.options.length>1&&s.offsetParent!==null&&![].some.call(s.options,function(o){return /yes/i.test(o.textContent);})&&!/quantity/i.test(dpoLabelFor(s));});}
  var optSels=getOptSels();
  var probeFns=[]; // per-size price fillers — run after path C primes the formula
  if(optSels.length){
    // "Fixed:" strip from the single-option DPO selects (e.g. 5mm Thickness · Single sided · Digital proof)
    var fixedBits=[];
    [].slice.call(document.querySelectorAll('select.product-custom-option')).forEach(function(s){
      if(s.options.length!==1)return;
      var v=s.options[0].textContent.trim(),lb=dpoLabelFor(s);
      if(/^yes/i.test(v)){if(lb)fixedBits.push(lb+' included');return;}
      fixedBits.push(v.length<=6&&lb?(v+' '+lb.toLowerCase()):v);
    });
    if(fixedBits.length){
      var stF=wrap.querySelector('.vvbc-strip');
      if(!stF){stF=document.createElement('div');stF.className='vvbc-strip';wrap.insertBefore(stF,wrap.firstChild);stF.innerHTML='<b>✓ Fixed:</b> '+fixedBits.join(' · ');}
      else stF.innerHTML=stF.innerHTML+' · '+fixedBits.join(' · ');
    }
    optSels.forEach(function(s){
      var lbl=dpoLabelFor(s)||'Option';
      var isSize=[].filter.call(s.options,function(o){return /\d+\s*mm\s*W/i.test(o.textContent);}).length>=2;
      if(isSize)vvPrepIll(s,cfg.handle,cfg.ptype,cfg.humanImg);
      /* same sales-driven badge on the ITORIS size groups (corflute-class products) */
      var vvBd=isSize?vvBest(cfg.handle):null, vvBdIx=-1;
      if(vvBd)[].forEach.call(s.options,function(o,ix){if(vvBdIx<0&&vvIsBest(vvBd,o.textContent))vvBdIx=ix;});
      var labD=document.createElement('div');labD.className='vvbc-label';
      labD.innerHTML='<b>'+lbl+':</b> <span class="vvbc-cur"></span>'+(isSize?tip('size'):'');
      var gridD=document.createElement('div');gridD.className='vvbc-cards'+(isSize?'':' vvbc-cards--extras');
      // keep prototype order: option groups sit ABOVE the Extras cards
      var anchorD=(exEl&&exEl.parentNode===wrap)?exEl:null;
      wrap.insertBefore(labD,anchorD);wrap.insertBefore(gridD,anchorD);
      var cardsD=[],userVal=s.value; // userVal = the customer's chosen option — probes must never stomp it
      [].forEach.call(s.options,function(o,i){
        var name=o.textContent.trim().replace(/\s+x\s+/i,' × ');
        var isCustom=/custom/i.test(name);
        var sub='';
        if(isSize){var wm=o.textContent.match(/(\d+)\s*mm\s*W\s*x\s*(\d+)\s*mm\s*H/i);
          if(wm)sub=(+wm[1]<+wm[2])?'portrait':'landscape';
          if(isCustom)sub='priced by area';}
        var pa=parseFloat(o.getAttribute('price')||'0');
        var c=document.createElement('button');c.type='button';c.className='vvbc-card'+(isSize?'':' vvbc-card--extra');c.setAttribute('data-dval',o.value);
        c.innerHTML=(isSize?vvIll(name):'')+
          '<span class="vvbc-nm">'+name+'</span>'+(sub?'<span class="vvbc-sub">'+sub+'</span>':'')+
          '<span class="vvbc-pr">'+(pa>0?'+ $'+pa.toFixed(2):(isSize?'':'Included'))+'</span>'+
          (i===(vvBdIx>=0?vvBdIx:0)?'<span class="vvbc-rec">'+(vvBdIx>=0?'BEST SELLER':'RECOMMENDED')+'</span>':'');
        c.addEventListener('click',function(){var ls=liveSel(s.name,s);userVal=o.value;ls.value=o.value;ls.dispatchEvent(new Event('change',{bubbles:true}));gsyncD();
          document.documentElement.classList.toggle('vvbc-showcustom',isCustom);
          setTimeout(function(){if(window.__vvbcSyncTotal)window.__vvbcSyncTotal();},250);});
        gridD.appendChild(c);cardsD.push({el:c,val:o.value,custom:isCustom});
      });
      function gsyncD(){var ls=liveSel(s.name,s);var v=ls.value;cardsD.forEach(function(x){x.el.classList.toggle('on',x.val===v);});
        var cur=labD.querySelector('.vvbc-cur');var so=null;[].forEach.call(ls.options,function(o){if(o.value===v)so=o;});
        if(cur&&so)cur.textContent=so.textContent.trim().replace(/\s+x\s+/i,' × ');}
      gsyncD();
      // hide the raw select row + its label
      var spD=s.parentElement;if(spD)spD.style.display='none';
      var qD=s,lD=null;for(var kD=0;kD<4&&qD;kD++){qD=qD.parentElement;if(qD){lD=qD.querySelector('label');if(lD&&lD.textContent.replace(/[*]/g,'').trim().indexOf(lbl)===0){lD.style.display='none';break;}}}
      if(isSize){ // fill per-size "from" rates (deepest visible tier = qty 100) once the formula is primed.
        // ITORIS applies changes on a debounce — steps are queued and run ~300ms apart by path C's chain().
        probeFns.push(function(h){
          var ls=liveSel(s.name,s),got={};
          h.queue.push(function(){ls=liveSel(s.name,ls);h.setQty(100);});
          cardsD.forEach(function(x){if(x.custom)return;
            h.queue.push(function(){ls.value=x.val;ls.dispatchEvent(new Event('change',{bubbles:true}));});
            h.queue.push(function(){var u=h.price();if(u){got[x.val]=u;x.el.querySelector('.vvbc-pr').textContent='$'+u.toFixed(2);}});
          });
          h.queue.push(function(){ls.value=userVal;ls.dispatchEvent(new Event('change',{bubbles:true})); // restore the CUSTOMER's pick, not a snapshot
            var best=null;for(var kk in got){if(best===null||got[kk]<best)best=got[kk];}
            if(best!==null)cardsD.forEach(function(x){if(x.custom)x.el.querySelector('.vvbc-pr').textContent='from $'+best.toFixed(2);});});
          h.restore=function(){var l2=liveSel(s.name,ls);l2.value=userVal;l2.dispatchEvent(new Event('change',{bubbles:true}));};
        });
      }
      // ITORIS re-renders selects after option changes — keep the raw row hidden
      setInterval(function(){var ls=liveSel(s.name,s);var sp2=ls&&ls.parentElement;if(sp2&&sp2.style.display!=='none')sp2.style.display='none';},2500);
    });
  }
  // QUANTITY TILES — path A: CRO custom dropdown. The CRO prices ANY quantity by RANGE tiers
  // (verified live: qty3 → 2+ tier unit, qty6 → 5+ tier unit, to the cent). We render the prototype
  // ladder (1-6 visible, 8/10/15/20 behind Show all) priced from the CRO's OWN tier numbers, and
  // proxy non-preset quantities through its custom-quantity path.
  var qtyBuilt=false;
  var qwrap=[].slice.call(document.querySelectorAll('.qty-wrapper')).find(function(w){return /Quantity/i.test(w.textContent)&&w.querySelector('ul.select-options');});
  if(qwrap){
    var lis=[].slice.call(qwrap.querySelectorAll('ul.select-options li'));
    var customLi=null,liByQty={},ladder=[];
    lis.forEach(function(li){
      var mm=li.textContent.trim().match(/^(\d+)\s*[×x|]?\s*\(?\s*\$([\d.,]+)/);
      if(!mm){customLi=li;return;}
      var q0=parseInt(mm[1],10),u0=parseFloat(mm[2].replace(/,/g,''));
      liByQty[q0]=li;ladder.push({q:q0,u:u0});
    });
    // 19-Aug (migration docs/06): NATIVE tier source — the vivid.tier_breaks metafield
    // wins when present ({min,pct} percent-off-variant-price rows, same data the
    // cart-transform Function charges from). No metafield (today: every product) =
    // unchanged ITORIS behaviour below. Selected-variant price is the base.
    var vvTB=null;
    try{ var raw=cfg.tierBreaks; if(typeof raw==='string')raw=JSON.parse(raw);
      if(raw && !Array.isArray(raw) && raw.enabled!==false) raw=raw.breaks;
      if(Array.isArray(raw)&&raw.length){ vvTB=raw.map(function(r){return {min:parseInt(r.min!=null?r.min:r.qty,10), pct:(r.pct!=null?parseFloat(r.pct):null), each:(r.each!=null?parseFloat(r.each):null)};})
        .filter(function(r){return r.min>=1&&((r.pct!=null&&r.pct>=0&&r.pct<100)||(r.each!=null&&r.each>0));}).sort(function(x,y){return x.min-y.min;}); if(!vvTB.length)vvTB=null; }
    }catch(e){vvTB=null;}
    if(vvTB){
      var vvSelBase=function(){ // current selected variant price, dollars
        try{ var sels2=[].slice.call(document.querySelectorAll('select[name*="options"], .product-form__input select'));
          var opts2=sels2.map(function(s){return s.value;});
          var v=cfg.variants.find(function(vv){return vv.opts.every(function(o,i){return !opts2[i]||o===opts2[i];});})||cfg.variants[0];
          return v?v.price/100:null; }catch(e){return null;} };
      /* R84 (28 Sep 2026): native unit is rounded to the cent with the SAME expression the cart
         Function charges ((base*(1-pct/100)).toFixed(2)), so tile = total = sticky = cart line to the
         cent. Before this the page multiplied the unrounded unit (26.125*5 -> $130.63 vs cart $130.65). */
      var vvTBLadder=function(base){ var L=vvTB.map(function(r){return {q:r.min, u:(r.each!=null?r.each:+(base*(1-r.pct/100)).toFixed(2))};});
        if(vvTB[0].min>1)L.unshift({q:1,u:base}); return L; };
      var b0=vvSelBase();
      if(b0!=null){ ladder=vvTBLadder(b0); }
    }
    // the CRO's tier rows are authoritative when present (same numbers as the LIs)
    var tierEls=[].slice.call(document.querySelectorAll('.itier_price[qty][price]'));
    if(!vvTB&&tierEls.length){ladder=tierEls.map(function(e2){return {q:parseInt(e2.getAttribute('qty'),10),u:parseFloat(e2.getAttribute('price'))};}).filter(function(t){return t.q&&t.u;});}
    ladder.sort(function(a,b){return a.q-b.q;});
    if(ladder.length){
      var unitFor=function(q){var u=ladder[0].u;for(var k2=0;k2<ladder.length;k2++){if(ladder[k2].q<=q)u=ladder[k2].u;}return u;};
      var QSET=[1,2,3,4,5,6,8,10,15,20];
      ladder.forEach(function(t){if(QSET.indexOf(t.q)<0)QSET.push(t.q);});
      QSET.sort(function(a,b){return a-b;});
      var ql2=document.createElement('div');ql2.className='vvbc-label vvbc-qlabel';ql2.innerHTML='<b>Quantity:</b> <span class="vvbc-qnow">1</span>'+tip('qty');wrap.appendChild(ql2);
      var qg2=document.createElement('div');qg2.className='vvbc-qty';wrap.appendChild(qg2);
      var tiles2=[],exRow=null;
      function setCustomQty(q){
        if(customLi){customLi.click();setTimeout(function(){[].forEach.call(qwrap.querySelectorAll('input[type=text], input[type=number]'),function(f){f.value=q;['input','change','keyup'].forEach(function(ev){f.dispatchEvent(new Event(ev,{bubbles:true}));});});},150);}
      }
      function selectQty(q,tileEl){
        window.__vvbcQty=q;   // authoritative chosen qty — see the note at tiles2[0] below
        if(liByQty[q]){liByQty[q].click();}else{setCustomQty(q);}
        tiles2.forEach(function(x){x.el.classList.remove('on');});
        if(tileEl)tileEl.classList.add('on');
        if(exRow){var f3=exRow.querySelector('input');if(f3)f3.value='';}
      }
      QSET.forEach(function(q,i){
        var u=unitFor(q);var save=Math.round((1-u/unitFor(1))*100);
        var t=document.createElement('button');t.type='button';t.className='vvbc-qtile'+(i>=6?' vvbc-qmore':'');
        t.innerHTML='<b>'+q+'</b><span class="vvbc-qp">$'+(u*q).toFixed(2)+'</span>'+(q>1?'<span class="vvbc-qs">$'+u.toFixed(2)+' ea'+(save>0?' · save '+save+'%':'')+'</span>':'');
        t.addEventListener('click',function(){vvPin(1200);selectQty(q,t);});
        qg2.appendChild(t);tiles2.push({el:t});
      });
      /* 21-Aug LIVE PRICING FIX (CRO-ladder path).
         A size change changes the VARIANT, so every price in this ladder is now
         for the wrong one. Measured live: fabric banners at 1500x5000 kept
         showing $49.00 while the variant costs $165.00 — the customer was
         quoted 3.4x under and only met the real price at checkout. (The cart
         posted the correct variant, so takings were right; the QUOTE was not.)
         Probed what actually happens on a size change: ITORIS DOES re-render
         its own tier rows with the new prices within ~1.5s
             before  1:49    2:46.55   5:44.1
             after   1:165   2:156.75  5:148.5
         but its #totalPrice element stays stale, and nothing re-read the rows
         into our tiles. So: re-read them and repaint. If the rows have not
         refreshed yet, fall back to the SELECTED SIZE tile's own variant price
         so the number shown is never under the real one. */
      window.__vvbcReprice=function(){
        /* R84: native-tier products have no ITORIS .itier_price rows, so the ITORIS path below fell
           back to the size card's BASE price and painted every tile undiscounted after a size change
           (900mm qty 5 showed $150.00; cart $142.50). Rebuild from vvTB + the newly selected variant. */
        if(vvTB){ try{ var bN=vvSelBase(); if(bN!=null){ ladder=vvTBLadder(bN); ladder.sort(function(a,b){return a.q-b.q;});
            var u1n=unitFor(1);
            tiles2.forEach(function(x,i){ var q=QSET[i]; if(!q)return; var u=unitFor(q), save=u1n>0?Math.round((1-u/u1n)*100):0;
              var qp=x.el.querySelector('.vvbc-qp'), qs=x.el.querySelector('.vvbc-qs');
              if(qp)qp.textContent='$'+(u*q).toFixed(2);
              if(qs)qs.textContent=q>1?('$'+u.toFixed(2)+' ea'+(save>0?' \u00b7 save '+save+'%':'')):''; });
            if(window.__vvbcSyncTotal)window.__vvbcSyncTotal(); return; } }catch(e){} }
        clearTimeout(window.__vvbcReprice._t);
        window.__vvbcReprice._t=setTimeout(function(){
          try{
            var te=[].slice.call(document.querySelectorAll('.itier_price[qty][price]'));
            var L=te.map(function(e2){return {q:parseInt(e2.getAttribute('qty'),10),u:parseFloat(e2.getAttribute('price'))};})
                    .filter(function(t){return t.q&&t.u;}).sort(function(a,b){return a.q-b.q;});
            if(!L.length){
              var sc=document.querySelector('.vvbc-card.on[data-val] .vvbc-pr');
              var sp=sc?parseFloat((sc.textContent||'').replace(/[^0-9.]/g,'')):0;
              if(sp>0)L=[{q:1,u:sp}];
            }
            if(!L.length)return;
            var uf=function(q){var u=L[0].u;for(var k=0;k<L.length;k++){if(L[k].q<=q)u=L[k].u;}return u;};
            var u1=uf(1);
            tiles2.forEach(function(x,i){
              var q=QSET[i]; if(!q)return;
              var u=uf(q), save=u1>0?Math.round((1-u/u1)*100):0;
              var qp=x.el.querySelector('.vvbc-qp'), qs=x.el.querySelector('.vvbc-qs');
              if(qp)qp.textContent='$'+(u*q).toFixed(2);
              if(qs)qs.textContent=q>1?('$'+u.toFixed(2)+' ea'+(save>0?' \u00b7 save '+save+'%':'')):'';
            });
            if(window.__vvbcSyncTotal)window.__vvbcSyncTotal();
          }catch(e){}
        },1200);
      };
      if(vvTB&&!window.__vvbcPriceFor){ window.__vvbcPriceFor=function(q){ return unitFor(q); }; } // R84: native exact-qty total
      // "Or enter exact quantity:" row (prototype)
      exRow=document.createElement('div');exRow.className='vvbc-exact';
      exRow.appendChild(document.createTextNode('Or enter exact quantity: '));
      var inp=document.createElement('input');inp.type='number';inp.min='1';inp.step='1';exRow.appendChild(inp);
      inp.addEventListener('change',function(){
        var n=parseInt(inp.value,10);if(!n||n<1)return;
        window.__vvbcQty=n;
        setCustomQty(n);
        tiles2.forEach(function(x){x.el.classList.remove('on');});
      });
      if(qg2.querySelectorAll('.vvbc-qmore').length){
        var more2=document.createElement('button');more2.type='button';more2.className='vvbc-qshow';more2.textContent='Show all quantities';
        more2.addEventListener('click',function(){var open=qg2.classList.toggle('all');more2.textContent=open?'Show fewer quantities':'Show all quantities';});
        wrap.appendChild(more2);
      }
      wrap.appendChild(exRow);
      // 21-Aug e2e (bollard covers): this path drives the ITORIS tier <li>s, never the legacy
      // input[name="quantity"], which keeps the PRODUCT's own default (3 on bollard covers). Every
      // CTA that reads that input — vivid-cc's qty(), the Shopify form — therefore ignored the tile
      // the customer picked: shown "2 · $38.00", added 3. window.__vvbcQty is the one number the
      // customer actually chose; qty() prefers it over the legacy input.
      if(tiles2.length){tiles2[0].el.classList.add('on');window.__vvbcQty=QSET[0];qwrap.style.display='none';qtyBuilt=true;}
    }
  }
  // path B: native qty select
  var qsel=[].slice.call(document.querySelectorAll('.qty-wrapper select, select[name*=quantity i]')).find(function(s){return [].some.call(s.options,function(o){return /^\s*\d+\s*[|×x]\s*\$/.test(o.textContent);});});
  if(!qwrap&&qsel){
    var ql=document.createElement('div');ql.className='vvbc-label';ql.innerHTML='<b>Quantity:</b> <span class="vvbc-qcur"></span>';wrap.appendChild(ql);
    var qg=document.createElement('div');qg.className='vvbc-qty';wrap.appendChild(qg);
    var base=null,tiles=[];
    [].forEach.call(qsel.options,function(o,i){
      var mm=o.textContent.match(/^\s*(\d+)\s*[|×x]\s*\$([\d.,]+)/);if(!mm)return;
      var qty=parseInt(mm[1],10),unit=parseFloat(mm[2].replace(/,/g,''));
      if(base===null)base=unit;
      var save=base>0?Math.round((1-unit/base)*100):0;
      var t=document.createElement('button');t.type='button';t.className='vvbc-qtile'+(i>=6?' vvbc-qmore':'');t.setAttribute('data-qv',o.value);
      t.innerHTML='<b>'+qty+'</b><span class="vvbc-qp">$'+(unit*qty).toFixed(2)+'</span>'+(qty>1?'<span class="vvbc-qs">$'+unit.toFixed(2)+' ea'+(save>0?' · save '+save+'%':'')+'</span>':'');
      t.addEventListener('click',function(){vvPin(1200);qsel.value=o.value;qsel.dispatchEvent(new Event('change',{bubbles:true}));qsync();});
      qg.appendChild(t);tiles.push({el:t,val:o.value,qty:qty});
    });
    if(qg.querySelectorAll('.vvbc-qmore').length){
      var more=document.createElement('button');more.type='button';more.className='vvbc-qshow';more.textContent='Show all quantities';
      more.addEventListener('click',function(){qg.classList.add('all');more.remove();});
      wrap.appendChild(more);
    }
    function qsync(){var v=qsel.value;tiles.forEach(function(t){t.el.classList.toggle('on',t.val===v);var c=ql.querySelector('.vvbc-qcur');if(c&&t.val===v){c.textContent=t.qty;window.__vvbcQty=t.qty;}});}
    qsync();
    var qf=qsel.closest('.qty-wrapper')||qsel.parentElement;if(qf)qf.style.display='none';
    if(tiles.length===0){ql.remove();qg.remove();if(qf)qf.style.display='';}else qtyBuilt=true;
  }
  // path C: formula-priced products (corflute-class) — no CRO ladder; qty is the Shopify stepper and
  // prices come from the ITORIS formula. The formula only answers AFTER one Calculate run, so we prime
  // it silently (pick "upload my files" + Calculate underneath the hidden legacy UI — the CTA flows
  // re-drive that state on click anyway), then probe the prototype ladder and fill the tiles.
  var qinp=document.querySelector('input[name="quantity"]');
  if(!qtyBuilt&&qinp&&optSels.length){
    if(qwrap)qwrap.style.display='none';
    var ql3=document.createElement('div');ql3.className='vvbc-label vvbc-qlabel';ql3.innerHTML='<b>Quantity:</b> <span class="vvbc-qnow">1</span>'+tip('qty');wrap.appendChild(ql3);
    var qg3=document.createElement('div');qg3.className='vvbc-qty';wrap.appendChild(qg3);
    var QS=[1,5,10,25,50,100,150,200,300,500]; // prototype ladder: first 6 visible, rest behind Show all
    var tiles3=[],exRow3=null;
    function setQty3(q){qinp.value=q;['input','change'].forEach(function(ev){qinp.dispatchEvent(new Event(ev,{bubbles:true}));});}
    function ownQty3(q){window.__vvbcQty=q;setQty3(q);}   // user intent, not a background probe
    function price3(){try{var p=window.dpoOptions.updatePrice().current_prices.price;return (typeof p==='number'&&p>0)?p:null;}catch(e){return null;}}
    window.__vvbcPriceFor=function(q){ // read-only when the qty is already applied (debounce-safe); else set+read best-effort
      if(String(qinp.value)===String(q))return price3();
      var q0=qinp.value;setQty3(q);var p=price3();setQty3(q0);return p;};
    // user intent beats background probes: track the chosen qty, abort probes on CTA click,
    // and always restore the USER's quantity/size when a chain ends or is aborted
    var userQty=1,activeChains=[];
    function chain3(steps,done){var i=0;var st={stopped:false};
      var iv=setInterval(function(){if(st.stopped||i>=steps.length){clearInterval(iv);if(!st.stopped&&done)done();if(st.stopped)setQty3(userQty);return;}try{steps[i]();}catch(e){}i++;},300);
      st.stop=function(){st.stopped=true;};activeChains.push(st);return st;}
    window.__vvbcAbortProbes=function(){activeChains.forEach(function(st){st.stop();});activeChains=[];setQty3(userQty);};
    function selQty3(q,tileEl){userQty=q;ownQty3(q);tiles3.forEach(function(x){x.el.classList.remove('on');});if(tileEl)tileEl.classList.add('on');
      if(exRow3){var f=exRow3.querySelector('input');if(f)f.value='';}}
    QS.forEach(function(q,i){
      var t=document.createElement('button');t.type='button';t.className='vvbc-qtile'+(i>=6?' vvbc-qmore':'');
      t.innerHTML='<b>'+q+'</b><span class="vvbc-qp"></span><span class="vvbc-qs"></span>';
      t.addEventListener('click',function(){vvPin(1200);selQty3(q,t);});
      qg3.appendChild(t);tiles3.push({el:t,q:q});
    });
    var more3=document.createElement('button');more3.type='button';more3.className='vvbc-qshow';more3.textContent='Show all quantities';
    more3.addEventListener('click',function(){var open=qg3.classList.toggle('all');more3.textContent=open?'Show fewer quantities':'Show all quantities';});
    wrap.appendChild(more3);
    exRow3=document.createElement('div');exRow3.className='vvbc-exact';
    exRow3.appendChild(document.createTextNode('Or enter exact quantity: '));
    var inp3=document.createElement('input');inp3.type='number';inp3.min='1';inp3.step='1';exRow3.appendChild(inp3);
    inp3.addEventListener('change',function(){var n=parseInt(inp3.value,10);if(!n||n<1)return;userQty=n;ownQty3(n);tiles3.forEach(function(x){x.el.classList.remove('on');});
      setTimeout(function(){if(window.__vvbcSyncTotal)window.__vvbcSyncTotal();},500);}); // re-read after ITORIS's debounce settles
    wrap.appendChild(exRow3);
    tiles3[0].el.classList.add('on');
    // 21-Aug e2e (bollard covers): the tile UI opens showing "Quantity: 1" and prices 1 unit, but
    // the hidden legacy input still carries the PRODUCT's default quantity — 3 on this product. Any
    // CTA that reads input[name="quantity"] (vivid-cc qty(), the Shopify form) therefore added 3
    // units for a $24 price the customer had just been shown. Push the UI's own default down into
    // the legacy input at build time so the two can never disagree before the first tile click.
    ownQty3(userQty);
    var qf3=qinp.closest('.product-form__input--quantity, quantity-input, .quantity')||qinp.parentElement;if(qf3)qf3.style.display='none';
    /* 21-Aug LIVE PRICING FIX. The probe below runs ONCE at page load and writes
       each quantity tile's price; syncTotal() then reads the selected tile. But
       nothing re-ran it when the customer changed SIZE, so the tiles — and the
       total — kept the FIRST variant's prices. Measured on the live site:
       fabric banners 1500x5000 showed $49.00 when the variant costs $165.00,
       bollard covers 270x1800 showed $19.00 against $30.00. The cart posted the
       right variant, so the money was right; the customer was simply quoted up
       to 3.4x too low and then met the real price at checkout.
       repriceAll() re-probes for the newly selected variant. It blanks the
       stale numbers FIRST, so a wrong price is never left on screen, and
       syncTotal()'s fallback (below) covers the gap with the selected size's own
       variant price x quantity — honest, and never under. */
    function repriceAll(){
      try{
        tiles3.forEach(function(x){
          var qp=x.el.querySelector('.vvbc-qp'), qs=x.el.querySelector('.vvbc-qs');
          if(qp)qp.textContent=''; if(qs)qs.textContent='';
        });
        if(window.__vvbcAbortProbes)window.__vvbcAbortProbes();
        if(window.__vvbcSyncTotal)window.__vvbcSyncTotal();   // paint the size-price fallback now
        clearTimeout(repriceAll._t);
        repriceAll._t=setTimeout(function(){
          var unitBy={},steps=[];
          QS.forEach(function(q){ steps.push(function(){setQty3(q);});
                                  steps.push(function(){unitBy[q]=price3();}); });
          steps.push(function(){setQty3(userQty);});
          chain3(steps,function(){
            var u1=unitBy[1];
            if(!u1){ if(window.__vvbcSyncTotal)window.__vvbcSyncTotal(); return; } // formula silent: keep the fallback
            tiles3.forEach(function(x){var u=unitBy[x.q];if(!u)return;
              var save=u1>0?Math.round((1-u/u1)*100):0;
              x.el.querySelector('.vvbc-qp').textContent='$'+(u*x.q).toFixed(2);
              if(x.q>1)x.el.querySelector('.vvbc-qs').textContent='$'+u.toFixed(2)+' ea'+(save>0?' \u00b7 save '+save+'%':'');
            });
            if(window.__vvbcSyncTotal)window.__vvbcSyncTotal();
          });
        },900);   // let ITORIS apply the new size on its own debounce first
      }catch(e){}
    }
    window.__vvbcReprice=repriceAll;
    // silent prime + probe (prices pop into the tiles as soon as the formula answers)
    setTimeout(function(){
      var upo=null;[].forEach.call(document.querySelectorAll('.requiredesignstep .flex-wrapper .option'),function(o){if(/upload my files/i.test(o.textContent))upo=o;});
      if(upo&&!upo.classList.contains('clicked'))(upo.querySelector('a')||upo).click();
      setTimeout(function(){
        var cbP=document.querySelector('.calculate-button');if(cbP)cbP.click();
        // primed-detection then a TIMED probe chain — ITORIS applies each change on a debounce,
        // so every set step and every read step get their own ~300ms tick.
        var triesP=0,p1a=null,phase=0;
        var ivP=setInterval(function(){
          triesP++;
          if(phase===0){p1a=price3();setQty3(5);phase=1;return;}
          if(phase===1){var p5=price3();setQty3(1);phase=0;
            var primed=p5&&p1a&&Math.abs(p5-p1a)>0.001;
            if(!primed&&triesP<20)return; // wait up to ~12s for the formula to come alive
            clearInterval(ivP);
            if(!primed)return; // formula never answered — tiles stay number-only, quote flow still works
            var unitBy={},steps=[];
            QS.forEach(function(q){
              steps.push(function(){setQty3(q);});
              steps.push(function(){unitBy[q]=price3();});
            });
            steps.push(function(){setQty3(userQty);});
            chain3(steps,function(){
              var u1=unitBy[1]||p1a;
              tiles3.forEach(function(x){var u=unitBy[x.q];if(!u)return;
                var save=u1>0?Math.round((1-u/u1)*100):0;
                x.el.querySelector('.vvbc-qp').textContent='$'+(u*x.q).toFixed(2);
                if(x.q>1)x.el.querySelector('.vvbc-qs').textContent='$'+u.toFixed(2)+' ea'+(save>0?' · save '+save+'%':'');
              });
              if(window.__vvbcSyncTotal)window.__vvbcSyncTotal();
              var sSteps=[],hs=[];
              probeFns.forEach(function(f){try{var h={queue:sSteps,setQty:setQty3,price:price3};f(h);hs.push(h);}catch(e){}});
              sSteps.push(function(){setQty3(userQty);});
              window.__vvbcRestoreSel=function(){hs.forEach(function(h){if(h.restore)try{h.restore();}catch(e){}});};
              chain3(sSteps,function(){if(window.__vvbcSyncTotal)window.__vvbcSyncTotal();});
            });
          }
        },600);
      },700);
    },1200);
  }
  // relocate the real H1 to full width above the two columns (prototype h1.page)
  var h1=document.querySelector('.product__title h1, h1.product__title, .product__info-wrapper h1, .product__info-container h1');
  var headWrap=document.querySelector('.vivid-pdphead');
  if(h1&&headWrap){var vvPh=headWrap.querySelector('.vvbc-h1--ph');if(vvPh)vvPh.remove();h1.classList.add('vvbc-h1');headWrap.appendChild(h1);headWrap.classList.add('vvbc-head-filled');}  /* release the parse-time 54px reservation in the same frame */
  // insert INSIDE the buy panel, above the quantity/variant fields (prototype order)
  vs.parentElement.insertBefore(wrap,vs);
  document.documentElement.classList.add('vvbc-on');
  // (v3 hides .calculate-button — our CTA buttons proxy-click it; no inline styling, it must stay display:none)
  // surgically hide the native fields the cards now drive
  if(sizeSel){var sf=sizeSel.closest('.qty-wrapper')||sizeSel.parentElement;if(sf)sf.style.display='none';
    [].forEach.call(document.querySelectorAll('variant-selects label, variant-selects .optionlabel'),function(l){if(l.textContent.trim()==='Size')l.style.display='none';});}
  // single-option variant selects (Display / Printed Sides) already summarised in the Included strip
  sels.forEach(function(s){if(s.options.length===1){var f=s.closest('.product-form__input')||s.parentElement;if(f)f.style.display='none';
    var lb=vs.querySelector('label[for="'+s.id+'"]');if(lb)lb.style.display='none';}});
  hideDpo();
  // ITORIS re-renders its option fields after variant changes — rebuild extras when that happens
  var moT=null;
  var mo=new MutationObserver(function(){clearTimeout(moT);moT=setTimeout(function(){
    var fresh=getDpo();
    if(fresh.length!==dpo.length||fresh.some(function(s){return s.offsetParent;}))buildExtras();
    setTimeout(syncExtras,400);setTimeout(syncExtras,1500); // ITORIS applies saved values late
  },350);});
  mo.observe(vs.parentElement,{childList:true,subtree:true});
  // card ON-state follows the real select (value writes don't emit mutations)
  document.addEventListener('change',function(e){if(e.target&&e.target.classList&&e.target.classList.contains('product-custom-option'))setTimeout(syncExtras,60);},true);
  setTimeout(syncExtras,1200);
  // prototype left column: move the old tab panes under the gallery as accordions
  var mc=document.querySelector('.product__media-wrapper');
  if(mc&&!document.querySelector('.vvd-acc')){
    [['desc','Description',false],['design-guide','Design guidelines',false],['our-process-tab','Ordering process',false]].forEach(function(a){ // all collapsed by default (user: expanded Description spoils the view)
      var p=document.getElementById(a[0]);if(!p)return;
      var d=document.createElement('details');d.className='vvd-acc';if(a[2])d.open=true;
      var su=document.createElement('summary');su.textContent=a[1];d.appendChild(su);
      mc.appendChild(d);d.appendChild(p);
    });
    function openHash(){var id=location.hash.slice(1);if(!id)return;var t=document.getElementById(id);var dd=t&&t.closest('details.vvd-acc');if(dd)dd.open=true;}
    window.addEventListener('hashchange',openHash);openHash();
  }
  // ===== v3: prototype lower flow — delivery rows + CTA buttons drive the legacy DPO controls =====
  // Legacy anatomy: design chooser .requiredesignstep .flex-wrapper .option (a.click selects, .clicked = on);
  // delivery .required-delivery .delivery-process .option (0=Delivery,1=Pick up); dispatch text .vq-dispatch-teaser;
  // action .calculate-button. All stay in DOM (hidden via CSS) — our buttons proxy clicks, resolved live per click.
  function designOpt(re){var os=document.querySelectorAll('.requiredesignstep .flex-wrapper .option');for(var i=0;i<os.length;i++){if(re.test(os[i].textContent))return os[i];}return null;}
  function delOpt(i){return document.querySelectorAll('.required-delivery .delivery-process .option')[i]||null;}
  /* 10-Sep: products without the design flow (hardware, frames) never build .vvbc-flow, so
     the sold-out box inside it never appears. After the synchronous build, if every variant is
     unavailable and no box exists yet, add one at the foot of the panel and grey the cards. */
  (function(){
    if(!cfg.variants||!cfg.variants.length||cfg.variants.some(function(v){return v.available!==false;}))return;
    setTimeout(function(){
      if(wrap.querySelector('.vvbc-oosbox'))return;
      var n=(cfg.variants.find(function(v){return v.note;})||{}).note||'';
      var d=document.createElement('div');d.className='vvbc-oosbox';
      d.innerHTML='<b>Out of stock</b>'+(n?' — '+n:' — restocking soon')+'. <a href="/pages/get-a-quote">Ask us for a restock date or an alternative</a>';
      wrap.appendChild(d);
      [].forEach.call(wrap.querySelectorAll('.vvbc-card'),function(c){c.classList.add('vvbc-oos');c.disabled=true;c.setAttribute('aria-disabled','true');var pr=c.querySelector('.vvbc-pr');if(pr)pr.textContent='Out of stock';var rc=c.querySelector('.vvbc-rec');if(rc)rc.remove();});
      var nb=document.getElementById('product-addTocart');if(nb)nb.style.display='none';
      wrap.classList.add('vvbc--oos');
    },50);
  })();
  if(document.querySelector('.calculate-button')&&designOpt(/upload my files/i)){
    var exOpt=designOpt(/expert designer/i);
    var exPrice=(exOpt&&(exOpt.textContent.match(/\$\s*[1-9][\d.,]*/)||[])[0])||null; // only a real non-zero price; never render "+ $0" (design price now loads from the new pricing system, not ITORIS)
    var flow=document.createElement('div');flow.className='vvbc-flow';
    flow.innerHTML='<div class="vvbc-label"><b>'+(isTableCover?'Estimated dispatch date':'Estimated delivery date')+'</b>'+tip('deliv')+'</div>'+
      '<div class="vvbc-drows">'+
      '<button type="button" class="vvbc-drow" data-del="0"><span class="vvbc-dt">Delivery</span><span class="vvbc-ds"></span><span class="vvbc-dr">Calculated at checkout</span></button>'+
      '<button type="button" class="vvbc-drow" data-del="1"><span class="vvbc-dt">Pick up</span><span class="vvbc-ds">Collect from our Derrimut VIC facility</span><span class="vvbc-dr">Free</span></button>'+
      '</div>'+
      (isTableCover?'<div class="vvbc-artnote vvbc-dispatchnote">Courier transit time is additional to production. See our <a href="/policies/shipping-policy">shipping policy</a> for delivery estimates.</div>':'')+
      '<div class="vvbc-deadline">⏱ Upload and approve your files before <b>3:00pm Melbourne time</b><span class="vvbc-dl-count"></span></div>'+
      '<div class="vvbc-total"><span>Total price:</span> <b class="vvbc-tp"></b> <em>inc GST</em><div class="vvbc-tsub"></div><div class="vvbc-chip">✓ Live prices from the Vivid Ads calculator</div></div>'+
      '<div class="vvbc-ctas">'+
      '<button type="button" class="vvbc-cta vvbc-cta--own">Order with my own design</button>'+
      '<button type="button" class="vvbc-cta vvbc-cta--canvas"><span class="vc-dot"></span>Design with AI<span class="vvbc-new" style="background:#D6202B;color:#fff;font-size:10px;font-weight:700;line-height:1;padding:2px 6px;border-radius:999px;margin-left:7px;vertical-align:middle;text-transform:uppercase;letter-spacing:.3px">New</span></button>'+
      '</div>'+
      /* Artwork timing, said out loud at the buy button. We had five lines of this
         copy across the theme and every one was buried in a tooltip, an accordion or
         the design modal - a customer scanning the page saw none of them. Helloprint
         makes the same promise structural (Upload is a named checkout step); the least
         we can do is put one visible sentence where the decision is actually made. */
      '<div class="vvbc-artnote"><b>Order now, upload your artwork after checkout.</b> Every printed order includes a free digital proof to approve before we print.</div>'+
      '<button type="button" class="vvbc-link" data-opt="expert">No artwork? Add our design service'+(exPrice?' (+ '+exPrice+')':'')+' — unlimited revisions</button>'+
      '<a class="vvbc-link" href="/pages/get-a-quote">Bulk run or custom job? Request a quote</a>';
    wrap.appendChild(flow);
    /* 10-Sep: nothing on this product is available (every variant is quantity 0 with
       continue-selling off). /cart/add would 422 and the overlay would hang, so say it
       plainly where the buy button was, keep the quote link, and hide the design-service
       upsell — there is nothing to design onto yet. */
    (function(){
      if(!cfg.variants||!cfg.variants.length||cfg.variants.some(function(v){return v.available!==false;}))return;
      var n=(cfg.variants.find(function(v){return v.note;})||{}).note||'';
      var ctas=flow.querySelector('.vvbc-ctas');
      if(ctas)ctas.innerHTML='<div class="vvbc-oosbox"><b>Out of stock</b>'+(n?' — '+n:' — restocking soon')+'. <a href="/pages/get-a-quote">Ask us for a restock date or an alternative</a></div>';
      [].forEach.call(flow.querySelectorAll('.vvbc-artnote'),function(an){an.remove();});
      var ex=flow.querySelector('.vvbc-link[data-opt="expert"]');if(ex)ex.remove();
      var dl=flow.querySelector('.vvbc-deadline');if(dl)dl.remove();
      /* nothing to price or ship: drop the delivery picker and the blank total, grey every
         size/option card, and hide Dawn's own disabled "Sold out" button — the box above says it. */
      ['.vvbc-drows','.vvbc-total'].forEach(function(q){var x=flow.querySelector(q);if(x)x.remove();});
      [].forEach.call(flow.querySelectorAll('.vvbc-label'),function(l){if(/(?:delivery|dispatch) date/i.test(l.textContent||''))l.remove();});
      [].forEach.call(wrap.querySelectorAll('.vvbc-card'),function(c){c.classList.add('vvbc-oos');c.disabled=true;c.setAttribute('aria-disabled','true');var pr=c.querySelector('.vvbc-pr');if(pr)pr.textContent='Out of stock';var rc=c.querySelector('.vvbc-rec');if(rc)rc.remove();});
      var nb=document.getElementById('product-addTocart');if(nb)nb.style.display='none';
      wrap.classList.add('vvbc--oos');
    })();
    /* vivid 24 Jul: NATIVE Shopify variant products (e.g. feather-flags) — options like Printed Sides /
       Flag Base live in <variant-selects> which renders AFTER our flow, stranding them below the CTAs.
       Move the WHOLE <variant-selects> element up (keeps its <select>s inside it so Dawn's variant JS
       keeps reading them) into a full-width leftover box above the flow. Skip on ITORIS products. */
    /* vivid 25 Jul v4: relocated native/DPO options (Printed Sides / Thickness / Page Size) must sit
       WITH the other pickers — above Quantity — not stranded in a box just before the CTA flow (which
       reads as a stray dropdown at the bottom of the panel). Anchor = the Quantity label; fall back to
       the flow only if no quantity block was built. */
    function vvLeftoverAnchor(){
      var q=wrap.querySelector('.vvbc-qlabel');
      if(!q){ q=[].filter.call(wrap.querySelectorAll('.vvbc-label'),function(l){return /^\s*Quantity/i.test(l.textContent||'');})[0]; }
      return q||flow;
    }
    function vvGetLeftover(nativeCls){
      var lv=wrap.querySelector(':scope > .vvbc-leftover');
      if(!lv){ lv=document.createElement('div'); lv.className='vvbc-leftover'; var anc=vvLeftoverAnchor(); anc.parentNode.insertBefore(lv,anc); }
      if(nativeCls) lv.classList.add('vvbc-leftover--native');
      return lv;
    }
    function vvMoveNativeVariants(){
      try{
        var vs2=document.querySelector('variant-selects');
        if(!vs2 || wrap.contains(vs2)) return;
        var isSize=function(u){var l=(u.querySelector('.optionlabel,label,.form__label')||{}).textContent||'';return /^\s*size\s*$/i.test(l.trim());};
        // visible native option units that are NOT Size (vvbc renders Size as cards)
        var units=[].filter.call(vs2.querySelectorAll('.selector-wrapper,.product-form__input'),function(u){return u.offsetParent && !isSize(u);});
        if(!units.length) return;                                              // pure-ITORIS / size-only → leave alone
        if(!(flow.compareDocumentPosition(vs2) & Node.DOCUMENT_POSITION_FOLLOWING)) return;
        // hide any Size unit so it isn't shown as a bare dropdown once relocated
        [].forEach.call(vs2.querySelectorAll('.selector-wrapper,.product-form__input'),function(u){ if(isSize(u)) u.style.display='none'; });
        var lv=vvGetLeftover(true);
        lv.appendChild(vs2);
      }catch(e){}
    }
    vvMoveNativeVariants(); setTimeout(vvMoveNativeVariants,1500);
    /* vivid 26 Jul: on native-migrated products, render the non-Size variant options (Printed Sides /
       Flag Base / Material …) as cards that match the Size cards, instead of bare relocated dropdowns.
       Gated to migrated products (native buy-flow marker) so ITORIS products are untouched. */
    var vvNativeMode = !!document.querySelector('.shopify-vivid-nativebuyflow[data-native="true"]');
    function vvOptionCards(){
      if(!vvNativeMode) return;
      var vs2=document.querySelector('variant-selects'); if(!vs2) return;
      var sels2=[].slice.call(vs2.querySelectorAll('select')).filter(function(s){
        if(s.__vvCarded || s.options.length<2) return false;
        var host=s.closest('.selector-wrapper,.product-form__input')||s.parentElement;
        var lt=((host&&host.querySelector('.optionlabel,label,.form__label')||{}).textContent||s.name||'').trim();
        return !/size/i.test(lt);
      });
      sels2.forEach(function(s){
        s.__vvCarded=true;
        /* 10-Sep: which product option is this select? Needed so a value with no available
           variant can be greyed out the same way an out-of-stock SIZE card is. Without this
           the card stayed clickable, set an unbuyable variant, and the customer only found
           out at the add-to-cart. (Real Estate Feather Flags, "Metal Plate (5kg)".) */
        var vvOptIx=-1;
        try{
          var vvNm=(s.name||'').replace(/^options\[|\]$/g,'').trim().toLowerCase();
          if(cfg.optionNames)for(var oi=0;oi<cfg.optionNames.length;oi++){
            if(String(cfg.optionNames[oi]).trim().toLowerCase()===vvNm){vvOptIx=oi;break;}
          }
        }catch(e){}
        var host=s.closest('.selector-wrapper,.product-form__input')||s.parentElement;
        var lbl=((host&&host.querySelector('.optionlabel,label,.form__label')||{}).textContent||s.name.replace(/^options\[|\]$/g,'')||'Option').replace(/\s+/g,' ').trim();
        var lab=document.createElement('div'); lab.className='vvbc-label'; lab.innerHTML='<b>'+lbl+':</b> <span class="vvbc-cur"></span>';
        var grid=document.createElement('div'); grid.className='vvbc-cards vvbc-cards--extras'; var cards=[];
        [].forEach.call(s.options,function(o){
          if(/\(?D#[A-Za-z0-9]{4,}/i.test(o.value)) return;
          var raw=o.textContent.replace(/\s+/g,' ').trim();
          var pm=raw.match(/\+\s*(?:AU\.)?\$?\s*([\d.,]+)/);
          var clean=raw.replace(/\s*\+\s*(?:AU\.)?\$?\s*[\d.,]+.*$/,'').replace(/\s*[""][^""]*[""]\s*/g,' ').replace(/\s+/g,' ').trim();
          var vvOos = vvOptIx>=0 && cfg.variants && cfg.variants.length &&
            !cfg.variants.some(function(v){ return v.opts[vvOptIx]===o.value && v.available!==false; });
          if(vvOos){
            var vvNote=(cfg.variants.find(function(v){return v.opts[vvOptIx]===o.value && v.note;})||{}).note||'';
            var u=document.createElement('button'); u.type='button';
            u.className='vvbc-card vvbc-card--extra vvbc-oos'; u.disabled=true;
            u.setAttribute('aria-disabled','true');
            u.setAttribute('data-tip','Out of stock'+(vvNote?' \u2014 '+vvNote:'')+'. Pick another option, or request a quote and we will hold your order for the next delivery.');
            u.innerHTML='<span class="vvbc-nm">'+clean+'</span>'+
              '<span class="vvbc-sub">'+(vvNote||'Restocking soon')+'</span>'+
              '<span class="vvbc-pr">Out of stock</span>';
            grid.appendChild(u);
            return;
          }
          var c=document.createElement('button'); c.type='button'; c.className='vvbc-card vvbc-card--extra';
          c.innerHTML='<span class="vvbc-nm">'+clean+'</span>'+(pm?'<span class="vvbc-pr">+ $'+pm[1]+'</span>':'');
          c.addEventListener('click',function(){ s.value=o.value; s.dispatchEvent(new Event('change',{bubbles:true}));
            cards.forEach(function(x){x.classList.remove('on');}); c.classList.add('on');
            var cur=lab.querySelector('.vvbc-cur'); if(cur)cur.textContent=clean;
            if(window.__vvbcSyncTotal){try{window.__vvbcSyncTotal();}catch(e){}}
            // the base / printed-sides just changed — every size card is quoting the old one
            if(window.__vvbcPaintSizeCards){try{window.__vvbcPaintSizeCards();}catch(e){}} });
          grid.appendChild(c); cards.push(c);
          if(o.selected){ c.classList.add('on'); var cur=lab.querySelector('.vvbc-cur'); if(cur)cur.textContent=clean; }
        });
        if(cards.length){ var anchor=vvLeftoverAnchor(); wrap.insertBefore(lab,anchor); wrap.insertBefore(grid,anchor); }
      });
      var lv2=wrap.querySelector('.vvbc-leftover--native'); if(lv2) lv2.style.display='none';   // hide raw dropdowns
    }
    vvOptionCards(); setTimeout(vvOptionCards,1600); setTimeout(vvOptionCards,3200);
    [0,1700,3300].forEach(function(ms){setTimeout(function(){if(window.__vvbcPaintSizeCards)window.__vvbcPaintSizeCards();},ms);});
    /* vivid 25 Jul v3: relocate ONLY options the panel truly did not map (Printed Sides / Thickness /
       Page Size strays below the CTAs). v1/v2 raced the DPO card builder and stole its selects,
       emptying the size cards. Now we WAIT until the builder has produced cards ([data-dval]) — or
       10s — and only then move what is still visible after the CTA flow. */
    var mvTries=0;
    var mvIv=setInterval(function(){
      mvTries++;
      var built=!!wrap.querySelector('[data-dval]');
      if(!built && mvTries<20) return;
      clearInterval(mvIv);
      try{
        var lo=[].filter.call(document.querySelectorAll('.wraper-form .product-custom-option'),function(el){
          if(!el.offsetParent || wrap.contains(el)) return false;
          if(el.closest('.requiredesignstep') || el.closest('.required-delivery') || el.closest('.vvbc-leftover')) return false;
          return !!(flow.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING);
        });
        if(lo.length){
          var lv=vvGetLeftover(false);
          lo.forEach(function(el){lv.appendChild(el);});
        }
        /* Hide ITORIS option rows left stranded AFTER the flow with no form control — these are the
           orphaned "Thickness / Printed Sides" labels whose <select>s were relocated above (the stray
           box at the bottom of the buy panel). Only rows with NO select/input are hidden, so functional
           options are never touched. */
        [].forEach.call(document.querySelectorAll('#itoris_dynamicproductoptions li, #itoris_dynamicproductoptions .field, .dpo-container li'),function(row){
          if(!row.offsetParent || wrap.contains(row)) return;
          if(row.querySelector('select,input,textarea,button')) return;
          if(flow.compareDocumentPosition(row) & Node.DOCUMENT_POSITION_FOLLOWING){ row.style.display='none'; }
        });
      }catch(e){}
    },500);
    function syncDel(){
      var t=document.querySelector('.vq-dispatch-teaser');
      // innerText of a display:none element is empty — parse textContent with anchored patterns
      var txt=t?t.textContent.replace(/\s+/g,' '):'';
      var mT=txt.match(/Dispatch\w*\s+[A-Z][a-z]+ \d{1,2} [A-Z][a-z]+/); // capitalised month stops before the run-on "Order"
      var mC=txt.match(/Order within\s*\d+\s*h\s*\d+\s*m/);
      var mP=txt.match(/(?:\d+\s*(?:hour|day)|Same day)\s*production/i); /* #113: teaser can now say day-tiers too */
      var r0=flow.querySelector('[data-del="0"]');
      if(r0&&mT){
        r0.querySelector('.vvbc-dt').textContent=mT[0];
        r0.querySelector('.vvbc-ds').textContent=['Delivery',mC&&mC[0],mP&&mP[0]].filter(Boolean).join(' · ');
      }
      var dl=flow.querySelector('.vvbc-dl-count');if(dl&&mC)dl.textContent=' · '+mC[0].replace(/Order within/i,'').trim()+' left';
      var os=document.querySelectorAll('.required-delivery .delivery-process .option');
      [].forEach.call(flow.querySelectorAll('.vvbc-drow'),function(r,i){r.classList.toggle('on',!!(os[i]&&os[i].classList.contains('clicked')));});
      // design-service price loads late in ITORIS — refresh the link once a real (non-$0) price shows
      var ex2=designOpt(/expert designer/i);
      var pm3=ex2&&(ex2.textContent.match(/\$\s*[1-9][\d.,]*/)||[])[0];
      var lk=flow.querySelector('[data-opt="expert"]');
      if(lk&&pm3&&lk.textContent.indexOf(pm3)<0)lk.textContent='No artwork? Add our design service (+ '+pm3+') — unlimited revisions';
    }
    // Total price mirrors the SELECTED quantity tile (the CRO's own numbers; custom qty → confirmed in quote)
    var pTitle=(document.querySelector('.vvbc-h1')||{textContent:''}).textContent.trim()||'this product';
    function syncTotal(){
      var tp=flow.querySelector('.vvbc-tp'),ts=flow.querySelector('.vvbc-tsub');if(!tp)return;
      var on=wrap.querySelector('.vvbc-qtile.on');
      var exIn=wrap.querySelector('.vvbc-exact input');
      if(!on&&exIn&&exIn.value){
        var qn0=wrap.querySelector('.vvbc-qnow');if(qn0)qn0.textContent=exIn.value;
        var nEx=parseInt(exIn.value,10);
        var pf=window.__vvbcPriceFor&&nEx>0?window.__vvbcPriceFor(nEx):null;
        if(pf){tp.textContent='$'+(pf*nEx).toFixed(2);ts.textContent=nEx+' × '+pTitle+' · $'+pf.toFixed(2)+' per unit';return;}
        tp.textContent='—';ts.textContent=exIn.value+' × '+pTitle+' · confirmed in your instant quote';return;}
      if(!on)return;
      var q=(on.querySelector('b')||{}).textContent||'1';
      var tot=(on.querySelector('.vvbc-qp')||{}).textContent||'';
      var ea=(on.querySelector('.vvbc-qs')||{}).textContent||'';
      var unit=ea?ea.split('·')[0].replace(/ea/i,'').trim():tot;
      /* 21-Aug: no probed price yet (first paint, or a size change in flight).
         Never show blank or a stale figure — use the SELECTED SIZE tile's own
         variant price x quantity. Correct at qty 1 and conservative in bulk
         (volume discounts appear when the probe lands), so the customer is
         never quoted under. */
      if(!tot){
        var sc=document.querySelector('.vvbc-card.on[data-val] .vvbc-pr');
        var sp=sc?parseFloat((sc.textContent||'').replace(/[^0-9.]/g,'')):0;
        var qn=parseInt(q,10)||1;
        if(sp>0){ tot='$'+(sp*qn).toFixed(2); unit='$'+sp.toFixed(2); }
      }
      tp.textContent=tot;
      ts.textContent=q+' × '+pTitle+' · '+unit+' per unit';
      var qn=wrap.querySelector('.vvbc-qnow');if(qn)qn.textContent=q;
    }
    window.__vvbcSyncTotal=syncTotal;
    /* 10-Sep: CORFLUTE — the "Total price" line right above the buy button was BLANK.
       syncTotal() reads the .vvbc-qtile quantity tiles, and on corflute the vcorf calculator
       replaces those tiles entirely, so it returned early at `if(!on)return` and never painted.
       The customer saw a correct total in the vcorf box, scrolled ~340px past the delivery
       picker, and arrived at the CTA under an empty price. Corflute is our #2 product by orders.
       Fix is display-only: MIRROR the string vcorf has already painted (never recompute), and
       re-mirror whenever vcorf repaints it. No price maths here, so this can never quote a
       number the customer has not already seen a few hundred pixels higher. */
    (function(){
      var vcRoot=document.getElementById('vcorf'); if(!vcRoot)return;
      var vcTot=vcRoot.querySelector('[data-total]'), vcEach=vcRoot.querySelector('[data-each]');
      if(!vcTot)return;
      var tp=flow.querySelector('.vvbc-tp'), ts=flow.querySelector('.vvbc-tsub');
      if(!tp)return;
      function mirror(){
        var t=(vcTot.textContent||'').trim();
        if(!t||t==='\u2014'){tp.textContent='';if(ts)ts.textContent='';return;}
        tp.textContent=t;
        if(!ts)return;
        var qEl=vcRoot.querySelector('[data-qty]');
        var q=qEl&&parseInt(qEl.value,10)>0?parseInt(qEl.value,10):null;
        var ea=vcEach?(vcEach.textContent||'').replace(/\s*ea\s*$/i,'').trim():'';
        ts.textContent=(q?q+' \u00d7 '+pTitle:pTitle)+(ea&&ea!=='\u2014'?' \u00b7 '+ea+' per sign':'');
      }
      mirror();
      try{ new MutationObserver(mirror).observe(vcTot,{childList:true,characterData:true,subtree:true}); }catch(e){}
      vcRoot.addEventListener('click',function(){setTimeout(mirror,80);});
      vcRoot.addEventListener('input',function(){setTimeout(mirror,80);});
    })();
    /* 24-Aug — "two banners, one artwork". A quantity is ONE design: a customer buying 2 with two
       different logos gets one cart line and one artwork slot, and nothing on the page said so
       until the artwork step. ~20 orders were cancelled and rebuilt by hand on 24 Aug because of
       it. State the rule where the quantity is chosen; the remedy is in the same sentence.
       DISPLAY ONLY — this reads the quantity that is ALREADY selected and touches no price, no
       variant data island and no cart payload. Hidden at quantity 1, so the panel is unchanged
       from today for the overwhelming majority of customers. Deliberately NOT folded into
       syncTotal(): that function returns early when the total element is missing, and the note
       must stay correct even then. */
    (function(){
      if(!window.__vvMulti)return;
      var qg=wrap.querySelector('.vvbc-qty');if(!qg)return;
      var note=window.__vvMulti.mount(qg);if(!note)return;
      /* The three qty paths all agree on these, in priority order: a TYPED exact quantity wins
         (tile clicks clear that field), then the selected tile, then the panel's own authoritative
         __vvbcQty. Anything blank or unparseable falls through to 1 → note stays hidden. */
      function qtyNow(){
        try{
          var ex=wrap.querySelector('.vvbc-exact input');
          if(ex&&ex.value!==''){var n=parseInt(ex.value,10);if(n>0)return n;}
          var on=wrap.querySelector('.vvbc-qtile.on b');
          if(on){var m=parseInt(on.textContent,10);if(m>0)return m;}
          var g=parseInt(window.__vvbcQty,10);if(g>0)return g;
        }catch(e){}
        return 1;
      }
      var t=null;
      function sync(){window.__vvMulti.set(note,qtyNow());}
      function soon(ms){clearTimeout(t);t=setTimeout(sync,ms||60);}
      window.__vvbcSyncMulti=sync;
      wrap.addEventListener('click',function(e){if(e.target.closest('.vvbc-qtile'))soon(80);});
      /* typed quantity: bind input AND change, debounced so it cannot flicker mid-keystroke */
      wrap.addEventListener('input',function(e){if(e.target.closest('.vvbc-exact'))soon(200);});
      wrap.addEventListener('change',function(e){if(e.target.closest('.vvbc-exact'))soon(200);});
      /* tiles are also repainted programmatically (size change, probe landing), which moves .on
         without a click. Watch the class attribute so the note can never go stale. Filtered to
         'class' on purpose: set() writes the `hidden` attribute, so this cannot re-trigger itself. */
      try{new MutationObserver(function(){soon(50);})
        .observe(wrap,{subtree:true,attributes:true,attributeFilter:['class']});}catch(e){}
      sync();
    })();
    wrap.addEventListener('click',function(e){if(e.target.closest('.vvbc-qtile'))setTimeout(syncTotal,60);});
    wrap.addEventListener('change',function(e){if(e.target.closest('.vvbc-exact'))setTimeout(syncTotal,60);});
    flow.addEventListener('click',function(e){
      var dr=e.target.closest('.vvbc-drow');
      if(dr){var o=delOpt(parseInt(dr.getAttribute('data-del'),10));if(o){(o.querySelector('a')||o).click();}setTimeout(syncDel,300);return;}
      // Full-screen progress overlay: reference/prototype show NO quote step — the ITORIS steps still
      // run underneath (pricing stays theirs) but the customer sees only "Adding to your basket…" → cart.
      // OPAQUE background (was rgba .45): the legacy quote/upload steps re-render and shuffle for
      // several seconds while the flow drives ITORIS — a translucent veil let customers watch those
      // "old screens loading in the back". Solid white hides them completely (display:none would
      // break the flow: liveAtc() needs offsetParent!==null on the ITORIS buttons).
      function vvOverlay(msg){var o=document.createElement('div');o.setAttribute('style','position:fixed;inset:0;z-index:99999;background:#fff;display:flex;align-items:center;justify-content:center;');o.innerHTML='<style>@keyframes vvsp{to{transform:rotate(360deg)}}</style>'+'<div style="background:#fff;border-radius:14px;padding:30px 44px;display:flex;flex-direction:column;align-items:center;gap:16px;box-shadow:0 12px 40px rgba(0,0,0,.18);">'+'<div style="width:40px;height:40px;border:4px solid #e2e2e2;border-top-color:#d6202b;border-radius:50%;animation:vvsp .8s linear infinite;font-size:0;line-height:0;">&nbsp;</div>'+'<div style="font-size:15px;font-weight:600;color:#191919;font-family:inherit;">'+msg+'</div></div>';
        // lock the page while the overlay is up so the add-flow's programmatic clicks can't scroll the
        // background around behind it (the "scrolling here and there" the customer sees).
        var sy=window.scrollY||window.pageYOffset||0;
        var de=document.documentElement, bd=document.body;
        var prev={hO:de.style.overflow,bO:bd.style.overflow,bP:bd.style.position,bT:bd.style.top,bW:bd.style.width};
        de.style.overflow='hidden'; bd.style.overflow='hidden'; bd.style.position='fixed'; bd.style.top=(-sy)+'px'; bd.style.width='100%';
        document.body.appendChild(o);
        var origRemove=o.remove.bind(o);
        o.remove=function(){ de.style.overflow=prev.hO; bd.style.overflow=prev.bO; bd.style.position=prev.bP; bd.style.top=prev.bT; bd.style.width=prev.bW; window.scrollTo(0,sy); origRemove(); };
        return o;}
      // helper: after Calculate, ITORIS marks the live add-to-cart with [dpo_add2cart]
      function liveAtc(){
        var bs=[].slice.call(document.querySelectorAll('#skip_upload,#continue_cart,#quote_to_cart_btn,button[onclick*="dpoOptions.addToCart"]')).filter(function(b){return b.offsetParent!==null&&!/display\s*:\s*none/i.test(b.getAttribute('style')||'');});
        return bs.find(function(b){return b.hasAttribute('dpo_add2cart');})||bs[0]||null;
      }
      // VividCanvas → PROTOTYPE FLOW: open the PitchPrint editor. Real anatomy: pick the design-studio
      // option, run Calculate, then the design step shows PitchPrint templates (.customize_design) whose
      // click boots PitchPrintClient (#pp-design-editor). We drive that chain and land in the editor.
      if(e.target.closest('.vvbc-cta--canvas')){
        if(window.__vvbcAbortProbes){window.__vvbcAbortProbes();if(window.__vvbcRestoreSel)window.__vvbcRestoreSel();} // background probes must not race the flow
        // Customer's Canvas (theme-wide, owner instruction 1 Aug): the VividCanvas button launches CC,
        // NOT PitchPrint. vivid-cc.liquid defines __vvCCLaunch on every PDP and hides this button on
        // products with no CC integration on storefront 54, so a click only reaches here for a linked
        // product. The PitchPrint chain below is now dead for this button (kept for reference/rollback).
        // 29-Sep AI Designer launch: this button opens the VividCanvas gallery
        // (ready-made designs, Design with AI, upload, blank) — vivid-buy-cards.liquid
        // defines __vvGalleryGo with the product and the chosen variant. The gallery's
        // ready-made picks come BACK here with ?vvstyle=, which still opens the studio
        // through __vvCCLaunch below, so that path is unchanged.
        if(typeof window.__vvGalleryGo==='function'){ window.__vvGalleryGo(); return; }
        if(typeof window.__vvCCLaunch==='function'){ window.__vvCCLaunch(); return; }
        // 2026-08-19: CC boot (vivid-cc.liquid, ~256KB) can lag the first paint. A tap that
        // arrived before __vvCCLaunch existed used to FALL INTO the dead PitchPrint chain
        // below, whose button-hunt matches ANY visible "Design online" text — including the
        // header nav link — and shipped the customer to an unrelated product page. Wait for
        // CC instead; the legacy chain is only reachable on products with no CC at all.
        if(window.__vvCCPending) return;              // already waiting on an earlier tap
        window.__vvCCPending=true;
        var ccOv=vvOverlay('Opening the design studio…');
        var ccTr=0;
        var ccT=setInterval(function(){
          ccTr++;
          /* 5-Oct (Q3): the late-boot poll prefers the gallery too — the studio's own
             grid is only ever a fallback on a page that cannot build a gallery URL. */
          if(typeof window.__vvGalleryGo==='function'){
            clearInterval(ccT); window.__vvCCPending=false; ccOv.remove(); window.__vvGalleryGo(); return;
          }
          if(typeof window.__vvCCLaunch==='function'){
            clearInterval(ccT); window.__vvCCPending=false; ccOv.remove(); window.__vvCCLaunch(); return;
          }
          if(ccTr>100){ // ~15s: give up loudly instead of navigating somewhere random
            clearInterval(ccT); window.__vvCCPending=false; ccOv.remove();
            /* 27 Aug — THE FAILURE NOBODY COULD SEE.
               This alert is the one the owner actually hits, and until now it was
               the ONLY failure path in the whole studio that reported nothing:
               fail_mount read 0 for the day while he was getting this message on
               his own PC. Every other route beacons; this one just told the
               customer and then forgot. So we kept diagnosing the paths that DO
               report, which is looking for the keys under the streetlight.
               Report the state that would tell us why __vvCCLaunch never arrived:
               did the script tag exist, was it neutered to type="lazyJs" by the
               optimiser in layout/theme.liquid, did the file actually load, and
               did anything throw. Best-effort and silent — a diagnostic must
               never be the reason a customer sees a second failure. */
            try{
              var tag=document.querySelector('script[src*="vivid-cc-app"]');
              var perf=[];
              try{ perf=performance.getEntriesByType('resource')
                     .filter(function(e){return /vivid-cc-app|vvreg-|vivid-cc\.css/.test(e.name);})
                     .map(function(e){return e.name.split('/').pop().split('?')[0]+':'+Math.round(e.duration)+'ms'+(e.transferSize===0&&e.decodedBodySize===0?':EMPTY':'');}); }catch(e){}
              var lazy=0,total=0;
              try{ var ss=[].slice.call(document.scripts); total=ss.length;
                   lazy=ss.filter(function(x){return x.type&&!/^(text\/javascript|module|application\/json|application\/ld\+json|text\/template)$/i.test(x.type);}).length; }catch(e){}
              var payload=JSON.stringify({
                ts:new Date().toISOString(), url:location.href.slice(0,300),
                productId:(window.__VVCC&&window.__VVCC.PRODUCT_ID)||null,
                handle:(window.__VVCC&&window.__VVCC.HANDLE)||null,
                entry:'buy-cards-launch-timeout', phase:'mount', final:true,
                attempts:1,
                stages:[
                  '0:__vvCCLaunch undefined after '+Math.round(ccTr*150/1000)+'s',
                  'script tag: '+(tag?('present type='+(tag.type||'(none)')):'MISSING FROM THE DOM'),
                  '__VVCC config: '+(window.__VVCC?'present':'MISSING'),
                  'modal in dom: '+(document.getElementById('vv-cc-modal')?'yes':'no'),
                  'scripts: '+total+' total, '+lazy+' neutered to a non-JS type',
                  'loaded: '+(perf.length?perf.join(' | '):'NONE of our assets finished loading'),
                  'readyState: '+document.readyState,
                  'firstError: '+(window.__vvFirstErr||'none captured')
                ],
                conn:(function(){try{var c=navigator.connection||{};return {et:c.effectiveType||'',dl:c.downlink||0,rtt:c.rtt||0};}catch(e){return {};}})(),
                ua:navigator.userAgent.slice(0,180), vp:innerWidth+'x'+innerHeight });
              var blob=new Blob([payload],{type:'text/plain'});
              if(!(navigator.sendBeacon&&navigator.sendBeacon('https://portal.vividads.com.au/api/cc-mount-failure',blob)))
                fetch('https://portal.vividads.com.au/api/cc-mount-failure',{method:'POST',body:payload,keepalive:true,headers:{'Content-Type':'text/plain'}}).catch(function(){});
            }catch(e){}
            /* 27 Aug — MAKE THE ADVICE WE GIVE ACTUALLY WORK. This alert says
               "refresh the page and try again", but a refresh clears the HTTP
               cache and NOT localStorage — and localStorage is where our own
               state lives (the 24h vv_cc_ok_* integration verdicts, cached
               probe tokens, the gallery row cache). The owner proved it: broken
               in his browser after a hard refresh, fine in incognito, same
               machine, same minute. So before telling the customer to refresh,
               drop every piece of our stored studio state; the refresh they are
               about to do then starts clean instead of replaying the wedge. The
               guest id survives on purpose — clearing it would orphan their
               saved designs. */
            try{
              for(var vi=localStorage.length-1;vi>=0;vi--){
                var vk=localStorage.key(vi);
                if(vk&&(vk.indexOf('vv_cc_ok_')===0||vk.indexOf('vv_cc_tok_')===0||vk.indexOf('vvbr_cache')===0))
                  localStorage.removeItem(vk);
              }
            }catch(e){}
            alert('The design studio is taking longer than usual to load. Please refresh the page and try again, or call 1300 721 614.');
          }
        },150);
        return;
        /* eslint-disable no-unreachable */
        if(window.__vqSetArt)window.__vqSetArt('ai');
        var cvOv=vvOverlay('Opening the design studio…');
        var cvTries=0,calcDone=false;
        var cvT=setInterval(function(){
          cvTries++;
          // editor already open?
          var ed=document.getElementById('pp-design-editor');
          if(ed&&!ed.classList.contains('hide')){clearInterval(cvT);cvOv.remove();ed.scrollIntoView({behavior:'smooth'});return;}
          // a PitchPrint template card ready → open the editor with it
          var tpl=document.querySelector('#pitchprint_designs_wrapper .pitchprint_design .customize_design, .pitchprint_design .customize_design');
          if(tpl){tpl.click();clearInterval(cvT);setTimeout(function(){cvOv.remove();},1200);return;}
          // post-quote design launcher visible? (AI Design Studio confirm / Start designing / active designbtn)
          var go=[].slice.call(document.querySelectorAll('button,a')).find(function(b){return b.offsetParent&&/^(AI Design Studio|Start designing|Design online)$/i.test((b.innerText||'').trim());});
          if(!go){var db=document.getElementById('designbtn');if(db&&db.offsetParent&&!/loading/i.test(db.textContent))go=db;}
          if(go){go.click();clearInterval(cvT);setTimeout(function(){cvOv.remove();},1400);return;}
          // otherwise: select the design/AI option, then calculate once
          var opt=designOpt(/ai design|design studio|online design|design tool/i);
          if(opt&&!opt.classList.contains('clicked')){(opt.querySelector('a')||opt).click();return;}
          if(opt&&!calcDone){calcDone=true;var cb3=document.querySelector('.calculate-button');if(cb3)cb3.click();return;}
          // widget boots lazily — nudge it into view so its observers fire
          if(!opt&&cvTries===6){var rd0=document.querySelector('.requiredesignstep');if(rd0&&rd0.scrollIntoView)rd0.scrollIntoView({block:'center'});}
          if(cvTries>=40){ // widget/templates unavailable — reveal native chooser so nothing dead-ends
            clearInterval(cvT);cvOv.remove();
            document.documentElement.classList.add('vvbc-showdpo');
            var rd=document.querySelector('.requiredesignstep .flex-wrapper');
            if(rd)rd.scrollIntoView({behavior:'smooth',block:'center'});
          }
        },500);
        return;
      }
      var own=e.target.closest('.vvbc-cta--own');
      var expert=e.target.closest('[data-opt="expert"]');
      var pick=own?/upload my files/i:expert?/expert designer/i:null;
      if(pick){
        if(window.__vvbcAbortProbes){window.__vvbcAbortProbes();if(window.__vvbcRestoreSel)window.__vvbcRestoreSel();} // background probes must not race the flow
        var op=designOpt(pick);
        if(op&&!op.classList.contains('clicked')){(op.querySelector('a')||op).click();}
        setTimeout(function(){var cb2=document.querySelector('.calculate-button');if(cb2)cb2.click();},250);
        if(own||expert){ // reference flow: straight to the basket — NO visible quote / upload step.
          // Reliable path: call ITORIS's own skip-upload add-to-cart (window.dpoOptions.addToCart on the
          // #skip_upload[dpo_add2cart] button) which adds the configured line + redirects to /cart. The old
          // flow walked the multi-step recap and un-hid the legacy quote/upload UI, stranding the customer.
          var ownOv=vvOverlay(expert?'Adding design service to your basket — our team will contact you for your brief after you place your order.':'Adding to your basket…');
          var n0=null;try{fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){n0=c.item_count;});}catch(err){}
          var tries=0,calcs=0,fired=0,lastFire=-99,done=false;
          /* 24-Aug bug #101: every route to the basket funnels through here (nativeAdd, the
             ITORIS success detector, vcorf). Add the design-fee line first, then navigate —
             otherwise the redirect cancels the in-flight fee request and the charge is lost. */
          function goCart(){ if(done)return; done=true; clearInterval(adv); vvFeeThen(function(){ try{window.__vvNoNav=1;}catch(e){} window.location.href='/cart'; }); }
          function nativeAdd(){ // non-ITORIS product (native Shopify variants) — plain add of the selected variant
            /* 01-Sep: this used to be document.querySelector('form[action*="/cart/add"]'),
               which matches Shopify's Shop Pay INSTALLMENTS stub form — it carries
               action="/cart/add" but no inputs, no buttons, no variant id, and it sits FIRST
               in the DOM. FormData() on it was empty, so none of the 34 hidden production
               properties in hidden_fields.liquid (_Bubble_Printer_Name, _ProductGroup, bleeds,
               dead areas, _TOTAL_SQM ...) ever reached the cart, and Switch had nothing to
               build a job ticket from. 884 line items 22-31 Aug. Pick the REAL product form:
               data-type="add-to-cart" first, then any cart form that actually carries
               properties[...] inputs, then the old behaviour as a last resort. */
            var vvForms=document.querySelectorAll('form[action*="/cart/add"]');
            var form=document.querySelector('form[action*="/cart/add"][data-type^="add-to-cart"]')
                  || Array.prototype.find.call(vvForms, function(f){
                       /* key on a REAL production field. Not just any properties[...] input:
                          PitchPrint injects _pitchprint/_pprint-* into the installments stub,
                          so "first form with any property" picks the wrong form on those PDPs. */
                       return f.querySelector('input[name="properties[_Bubble_Printer_Name]"]'); })
                  || Array.prototype.find.call(vvForms, function(f){
                       return f.querySelector('[name="add"],button[type="submit"],input[type="submit"]'); })
                  || vvForms[0];
            if(!form) return false;
            var fd=new FormData(form);
            /* 01-Sep (second pass — Shabbir, Loose Tablecloth). Choosing ONE form was the
               wrong shape. On every ITORIS-descended PDP the two /cart/add forms split the
               job between them: the variant picker holds name="id" and almost no properties,
               while data-type="add-to-cart-form" holds the 27-35 production properties and
               NO variant id at all. The pass above correctly started picking the property
               form — and then posted it with no id, so /cart/add.js rejected it and NOTHING
               was added. Verified broken on loose/fitted/stretch tablecloths, table throws,
               round throws, table runner, selfie frames, pull-ups and fabric banners.
               So: merge instead of choose. Keep this form's properties, and borrow the
               variant id (and any properties only the other forms carry) from its sibling. */
            if(!fd.get('id')){
              var vvVid=null;
              for(var vfi=0;vfi<vvForms.length;vfi++){
                if(vvForms[vfi]===form) continue;
                var vvCand=new FormData(vvForms[vfi]).get('id');
                if(vvCand){vvVid=vvCand;break;}
              }
              if(!vvVid){var vvIdEl=document.querySelector('form[action*="/cart/add"] [name="id"]'); if(vvIdEl&&vvIdEl.value) vvVid=vvIdEl.value;}
              if(!vvVid&&window.__VVCC&&window.__VVCC.FALLBACK_VID) vvVid=window.__VVCC.FALLBACK_VID;
              if(vvVid) fd.set('id',vvVid);
            }
            /* don't lose properties the sibling form carries on its own (PitchPrint's
               _pitchprint/_pprint-* markers used to ride along on the old code path) */
            try{
              for(var vfj=0;vfj<vvForms.length;vfj++){
                if(vvForms[vfj]===form) continue;
                new FormData(vvForms[vfj]).forEach(function(v,k){ if(/^properties\[/.test(k)&&!fd.has(k)) fd.set(k,v); });
              }
            }catch(e){}
            if(!fd.get('id')) return false; // no id anywhere — let the caller keep waiting rather than post a request we know fails
            try{ // include selected variant options as line-item properties so the cart itemises them (reference style)
              document.querySelectorAll('variant-selects select').forEach(function(sel){
                var nm=(sel.name||'').replace(/^options\[|\]$/g,'');
                var op=sel.options[sel.selectedIndex];
                if(nm && op && !/^default/i.test(nm)){
                  var v=op.textContent.replace(/\s+/g,' ').replace(/\s*\(?D#[A-Za-z0-9]{4,}\)?/,'').replace(/\s*-\s*SALE!?/i,'').trim();
                  if(v) fd.set('properties['+nm+']', v);
                }
              });
            }catch(e){}
            var onq=wrap.querySelector('.vvbc-qtile.on b'); var exq=wrap.querySelector('.vvbc-exact input');
            var qv=(exq&&exq.value)?parseInt(exq.value,10):(onq?parseInt((onq.textContent||'1'),10):1);
            if(qv>0){fd.set('quantity',qv);}
            var sd=window.__vvSameDay;
            if(sd&&sd.active&&sd.variant){
              // multi-item add: main product (with its properties) + one Same Day Production surcharge line
              var vid=fd.get('id'); var props={};
              try{ fd.forEach(function(val,key){ var m=/^properties\[(.+)\]$/.exec(key); if(m) props[m[1]]=val; }); }catch(e){}
              props['_sameday']='1';   // hidden marker so the cart shows "Same Day production" on this line's Delivery row
              fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
                body:JSON.stringify({items:[{id:parseInt(vid,10),quantity:qv,properties:props},{id:parseInt(sd.variant,10),quantity:1}]})})
                .then(function(r){return r.json();}).then(function(j){ if(j&&(j.items||j.id!==undefined)){goCart();} else {ownOv.remove();} }).catch(function(){ownOv.remove();});
            } else {
              fetch('/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(j){ if(j&&(j.id!==undefined||j.product_title)){goCart();} else {ownOv.remove();} }).catch(function(){ownOv.remove();});
            }
            return true;
          }
          var itoris = !!(window.dpoOptions && (document.getElementById('skip_upload')||document.querySelector('.requiredesignstep')));
          // 19-Aug (migration docs/06): corflute-class page running the NATIVE calculator with
          // DPO gone — the calc's own add button carries the full Size/Thickness/Printing/
          // Eyelets/Cutting properties + quantity and redirects to /cart itself. Without this,
          // the flow fell to nativeAdd() and added the bare variant with NO properties.
          var vcorfBtn=document.querySelector('.vcorf [data-add]');
          var vcorfMode=!!(vcorfBtn && !window.dpoOptions);
          var vvNadd={tries:0,fired:false};
          var adv=setInterval(function(){
            tries++;
            if(done)return;
            // success detector — ITORIS may add via AJAX just before its own redirect
            if(n0!==null){ fetch('/cart.js',{headers:{Accept:'application/json'},cache:'no-store'}).then(function(r){return r.json();}).then(function(c){ if(!done&&c.item_count>n0){goCart();} }).catch(function(){}); }
            if(vcorfMode){
              if(tries===2){try{vcorfBtn.click();}catch(e){}}
              if(tries>50){clearInterval(adv);ownOv.remove();}
              return;
            }
            if(itoris){
              var atc=document.querySelector('#skip_upload[dpo_add2cart]');
              if(!atc){var su=document.getElementById('skip_upload');if(su&&/addToCart/.test(su.getAttribute('onclick')||''))atc=su;}
              var ready=atc&&window.dpoOptions&&typeof window.dpoOptions.addToCart==='function';
              if(ready&&tries>=5&&fired<2&&(tries-lastFire)>=12){ // fire once ITORIS has computed; one conservative retry
                fired++;lastFire=tries;
                try{window.dpoOptions.addToCart(atc,new Event('click'));}catch(e){try{atc.click();}catch(_){}}
              }
              if(!ready&&tries%5===2&&calcs<5){calcs++;var cbr=document.querySelector('.calculate-button');if(cbr)cbr.click();}
            } else if(tries>=3 && !vvNadd.fired && tries%4===3 && vvNadd.tries<3){
              /* 01-Sep: was a single shot at tries===3. nativeAdd() now returns false when the
                 variant id is not on the page yet (picker still hydrating), so give it three
                 goes ~2s apart instead of silently doing nothing for the next 24 seconds. */
              vvNadd.tries++; if(nativeAdd()) vvNadd.fired=true;
            } // native product — plain /cart/add
            if(tries>50){clearInterval(adv);ownOv.remove();}
          },500);
        }
      }
    });
    syncTotal();setTimeout(syncTotal,2500);
    syncDel();setTimeout(syncDel,2000);setTimeout(syncDel,6000);setInterval(syncDel,30000);
    var tEl=document.querySelector('.vq-dispatch-teaser');
    if(tEl&&window.MutationObserver){new MutationObserver(function(){syncDel();}).observe(tEl,{childList:true,subtree:true,characterData:true});}
  }
  function sync(){
    if(!sizeSel)return;var v=sizeSel.value;
    [].forEach.call(wrap.querySelectorAll('.vvbc-card[data-val]'),function(c){c.classList.toggle('on',c.getAttribute('data-val')===v);});
    var cur=wrap.querySelector('.vvbc-cur');if(cur)cur.textContent=v.replace(/\s*-\s*SALE!?/i,'').replace(/\s+x\s+/i,' × ');
  }
  sync();
}
/* speed-optimizer can hold DOMContentLoaded handlers until first interaction — timer fallbacks (boot is idempotent) */
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);setTimeout(boot,1500);setTimeout(boot,4000);
  /* R87 B2 (28 Sep 2026): DOMContentLoaded waits for the rest of the ~660KB page, the synchronous /apps/design
     widget script and every deferred script. boot() only reads markup rendered inside the main-product section
     (#vvbc-data, variant-selects, the native-buyflow marker), so build as soon as the parser has moved past
     that section. DOMContentLoaded + the timers above stay as idempotent fallbacks (boot returns once .vvbc exists). */
  (function(){try{
    var d=document.getElementById('vvbc-data'),sec=d&&d.closest('.shopify-section');
    if(!sec||!window.MutationObserver)return;
    /* ITORIS DPO products keep the DOMContentLoaded build: their curtain waits for DPO + a quiet box, and building
       the cards during DPO start-up was measured to lengthen that wait on mobile (+1.2-1.6s). */
    if(document.querySelector('script[src*="itoris.com/dpo/storefront/include.js"]'))return;
    var c0={};try{c0=JSON.parse(d.textContent)||{};}catch(e){}
    /* Calculator products keep the DOMContentLoaded build (owner decision 28 Sep: no change to their buy box).
       Keep in step with vcorf_handles (vivid-corflute-calc) and vvcalc_handles (vivid-calc-products). */
    if(/^(corrugated-plastic-signs|plastic-flute-board-signs|pvc-foam-board-signs|fabric-banners)$/.test(c0.handle||'')||/[?&]vv_calc=1/.test(location.search))return;
    /* start the ~1KB best-seller map fetch now, so boot()'s (700ms-capped) wait for it is usually already over */
    if(c0.bestUrl&&!window.__VVBEST_URL){window.__VVBEST_URL=c0.bestUrl;vvLoadBest();}
    var past=function(){return !!(sec.nextElementSibling||(sec.parentElement&&sec.parentElement.nextElementSibling));};
    if(past()){boot();return;}
    var mo=new MutationObserver(function(){if(past()){mo.disconnect();window.__vvbcEarly=Math.round(performance.now());boot();}});
    mo.observe(document.documentElement,{childList:true,subtree:true});
    document.addEventListener('DOMContentLoaded',function(){mo.disconnect();});
  }catch(e){}})();
}else boot();
})();
